/* ============================================================
   5. WOMUSE BAG — bag, private selection, gift, second piece
   ------------------------------------------------------------
   Runs when Quick cart > Cart design = "WOMUSE Bag v11".

   - Never re-prices anything: prices, savings and totals come from
     Shopify (Liquid cart + discount allocations). The second-piece
     discount and the gift are applied at checkout by the WOMUSE
     Rewards discount, which reads the same WOMUSE Promotions entries.
   - Marks the piece added after her first piece with the line
     property _womuse_selection (from the bag, product pages and
     collection quick add) and an accepted gift with _womuse_gift.
   - After every change it re-renders the bag from the quick-cart
     section and fires Stiletto's own refresh event.
   - Favourites and recently viewed pieces are kept in this browser.
   - Does not modify theme.js.
   ============================================================ */

(function () {
  'use strict';
  if (window.WOMUSE_V11_INIT) return;
  window.WOMUSE_V11_INIT = true;

  var ROOT = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '/');
  var UNDO_KEY = 'wv11-undo';
  var ASIDE_KEY = 'wv11-gift-aside';
  var CAT_KEY = 'wv11-cat-v7';
  var DESK = window.matchMedia ? window.matchMedia('(min-width: 960px)') : { matches: false };
  var RECENT_KEY = 'wv11-recent';
  var FAV_KEY = 'wv11-favs';
  var FAV_URL = ROOT + 'collections/all?view=favourites';
  var UNDO_MS = 10000;
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var ui = { sel: 'closed', selMetal: null, altOpen: false, giftPick: null, giftVariant: null, details: false, codeOpen: false, panel: null };
  var catalog = null, catalogLoading = null;
  var products = {};

  /* ---------------- 5.1 helpers ---------------- */

  function drawer() { return document.querySelector('.quick-cart.womuse-v11'); }
  function q(sel, el) { return (el || document).querySelector(sel); }
  function qa(sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function json(el) { if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  function readState() { var d = drawer(); return json(d && q('[data-wv11-state]', d)); }
  function readGlobal() { return json(q('[data-wv11-global]')); }
  function store(key, val) { try { if (val == null) sessionStorage.removeItem(key); else sessionStorage.setItem(key, JSON.stringify(val)); } catch (e) {} }
  function load(key) { try { return JSON.parse(sessionStorage.getItem(key)); } catch (e) { return null; } }
  function keep(key, val) { try { localStorage.setItem(key, JSON.stringify(val)); } catch (e) {} }
  function kept(key) { try { return JSON.parse(localStorage.getItem(key)) || []; } catch (e) { return []; } }
  function fill(text, s) { return String(text || '').replace(/\[percent\]/g, s ? s.percent : ''); }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  function money(cents, format) {
    format = format || '£{{amount}}';
    var n = (Number(cents) || 0) / 100;
    function fmt(num, dec, th, de) {
      var parts = num.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts.join(de);
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return fmt(n, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return fmt(n, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return fmt(n, 0, '.', ',');
      return fmt(n, 2, ',', '.');
    });
  }

  function post(path, body) {
    return fetch(ROOT + path, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.json().catch(function () { return {}; }).then(function (j) { throw new Error(j.description || j.message || ('Cart error ' + r.status)); });
      return r.json();
    });
  }
  function getCart() { return fetch(ROOT + 'cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }); }

  // Re-render the bag (title count, delivery, lines, footer, shared state)
  // from the quick-cart section, then let Stiletto update the header count.
  function refresh() {
    var qc = drawer();
    var id = qc && qc.getAttribute('data-section-id');
    if (!id) { document.dispatchEvent(new Event('apps:product-added-to-cart')); return Promise.resolve(); }
    return fetch(ROOT + '?section_id=' + encodeURIComponent(id), { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.quick-cart');
        if (fresh && fresh.querySelector('.quick-cart__items') && qc.querySelector('.quick-cart__items')) {
          ['.quick-cart__heading', '[data-wv11-delivery]', '.quick-cart__items', '.quick-cart__footer-inner', '[data-wv11-global-wrap]'].forEach(function (sel) {
            var a = qc.querySelector(sel), b = fresh.querySelector(sel);
            if (!a || !b) return;
            if (sel === '[data-wv11-delivery]' && a.querySelector('[data-wv11-delivery-sig]') && b.querySelector('[data-wv11-delivery-sig]') &&
              a.querySelector('[data-wv11-delivery-sig]').getAttribute('data-wv11-delivery-sig') === b.querySelector('[data-wv11-delivery-sig]').getAttribute('data-wv11-delivery-sig')) return;
            var top = a.scrollTop;
            var wasDone = sel === '[data-wv11-delivery]' && !!a.querySelector('.wv11-delivery.is-done');
            var oldTrk = sel === '[data-wv11-delivery]' ? a.querySelector('[data-wv11-trk]') : null;
            var oldP = oldTrk ? oldTrk.style.getPropertyValue('--p') : '';
            a.innerHTML = b.innerHTML;
            a.scrollTop = top;
            // She has just reached complimentary delivery: the bar fills and lands on
            // the tick, then folds away after 2 seconds
            var nowDone = sel === '[data-wv11-delivery]' && a.querySelector('.wv11-delivery.is-done');
            if (nowDone && !wasDone && oldTrk && !REDUCED) {
              nowDone.classList.add('is-arriving');
              setTimeout(function () { nowDone.classList.add('is-folding'); }, 2200);
              setTimeout(function () { nowDone.classList.remove('is-arriving', 'is-folding'); }, 2700);
            }
            var newTrk = oldP && a.querySelector('[data-wv11-trk]');
            if (newTrk && !REDUCED) {
              var newP = newTrk.style.getPropertyValue('--p');
              newTrk.classList.add('is-still'); newTrk.style.setProperty('--p', oldP);
              void newTrk.offsetWidth; newTrk.classList.remove('is-still');
              requestAnimationFrame(function () { newTrk.style.setProperty('--p', newP); });
            }
          });
        }
        document.dispatchEvent(new Event('apps:product-added-to-cart'));
        sync();
      })
      .catch(function (e) {
        console.error('[WOMUSE bag] refresh', e);
        document.dispatchEvent(new Event('apps:product-added-to-cart'));
      });
  }

  var ICON = {
    lock: '<svg width="11" height="11" viewBox="0 0 24 24" aria-hidden="true"><path class="wv11-shackle" d="M8 11V8a4 4 0 018 0v3" fill="none" stroke="currentColor" stroke-width="2.4"/><rect x="5" y="10.5" width="14" height="11" rx="2" fill="currentColor"/></svg>',
    arrow: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>',
    close: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    back: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>',
    search: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-4-4"/></svg>',
    next: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M9 4l8 8-8 8"/></svg>',
    prev: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M15 4l-8 8 8 8"/></svg>',
    plane: '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" aria-hidden="true"><path transform="rotate(90 12 12)" d="M21 16v-2l-8-5V3.5a1.5 1.5 0 0 0-3 0V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"/></svg>',
    giftSm: '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><rect x="3" y="9" width="18" height="12" rx="1"/><path d="M3 13h18M12 9v12M12 9c-2-4-6-4-6-1.5S10 9 12 9zm0 0c2-4 6-4 6-1.5S14 9 12 9z"/></svg>',
    chev: '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>',
    chevUp: '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 15l6-6 6 6"/></svg>',
    up: '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 19V5M6 11l6-6 6 6"/></svg>',
    gift: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><rect x="3" y="9" width="18" height="12" rx="1"/><path d="M3 13h18M12 9v12M12 9c-2-4-6-4-6-1.5S10 9 12 9zm0 0c2-4 6-4 6-1.5S14 9 12 9z"/></svg>',
    heart: '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.3-9.2C1.4 7.9 3.6 4.5 7 4.5c2 0 3.6 1.1 5 3 1.4-1.9 3-3 5-3 3.4 0 5.6 3.4 4.3 6.8-1.8 4.6-9.3 9.2-9.3 9.2z"/></svg>',
    heartFull: '<svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.3-9.2C1.4 7.9 3.6 4.5 7 4.5c2 0 3.6 1.1 5 3 1.4-1.9 3-3 5-3 3.4 0 5.6 3.4 4.3 6.8-1.8 4.6-9.3 9.2-9.3 9.2z"/></svg>'
  };

  /* ---------------- 5.2 favourites + recently viewed ---------------- */

  function favs() { return kept(FAV_KEY); }
  function isFav(h) { return favs().indexOf(h) >= 0; }
  function toggleFav(h) {
    var list = favs().filter(function (x) { return x !== h; });
    if (!isFav(h)) list.unshift(h);
    keep(FAV_KEY, list.slice(0, 60));
    paintHearts();
    qa('[data-wv11-fav-count]').forEach(function (c) { c.textContent = list.length; c.hidden = !list.length; });
  }
  function paintHearts() {
    qa('[data-wv11-fav]').forEach(function (b) { b.setAttribute('aria-pressed', String(isFav(b.dataset.wv11Fav))); });
  }
  function heartBtn(h, title) {
    return '<button type="button" class="wv11-heart" data-wv11-fav="' + esc(h) + '" aria-pressed="' + isFav(h) + '" aria-label="Save ' + esc(title) + ' to favourites">' + ICON.heart + '</button>';
  }
  function recordRecent() {
    var m = location.pathname.match(/\/products\/([^/?#]+)/); if (!m) return;
    var list = kept(RECENT_KEY).filter(function (h) { return h !== m[1]; });
    list.unshift(m[1]);
    keep(RECENT_KEY, list.slice(0, 12));
  }

  /* ---------------- 5.3 eligible pieces + suggestions ---------------- */

  var GROUP_ORDER = ['Rings', 'Necklaces', 'Earrings', 'Bracelets', 'Charms'];

  function loadCatalog(s) {
    if (catalog) return Promise.resolve(catalog);
    if (catalogLoading) return catalogLoading;
    var cached = load(CAT_KEY);
    if (cached && cached.ts && Date.now() - cached.ts < 30 * 60 * 1000 && cached.data) {
      catalog = buildCatalog(cached.data);
      return Promise.resolve(catalog);
    }
    var url = (s && s.catalogUrl) || (ROOT + '?section_id=womuse-v11-catalog');
    catalogLoading = fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var m = html.match(/<script[^>]*data-wv11-catalog[^>]*>([\s\S]*?)<\/script>/);
        var data = m ? JSON.parse(m[1]) : { products: [] };
        var rm = html.match(/<script[^>]*data-wv11-rings[^>]*>([\s\S]*?)<\/script>/);
        if (rm) { try { data.rings = JSON.parse(rm[1]); } catch (e) {} }
        store(CAT_KEY, { ts: Date.now(), data: data });
        catalog = buildCatalog(data);
        catalogLoading = null;
        return catalog;
      })
      .catch(function (e) { console.error('[WOMUSE bag] catalogue', e); catalogLoading = null; catalog = buildCatalog({ products: [] }); return catalog; });
    return catalogLoading;
  }

  function buildCatalog(data) {
    if (data.rings && data.rings.length) { setRings(data.rings); setTimeout(paintRingPills, 0); }
    var c = { products: data.products || [], byHandle: {}, groups: [], stones: {} , noStone: 0, shapes: {}, colls: {} };
    c.products.forEach(function (p) {
      c.byHandle[p.h] = p;
      p.fam = p.f ? p.f.split(' ') : [];
      p.imgs = [p.i].concat(p.m || []).filter(Boolean);
      if (p.g && c.groups.indexOf(p.g) < 0) c.groups.push(p.g);
      if (p.s) c.stones[p.s] = (c.stones[p.s] || 0) + 1; else c.noStone++;
      if (p.c) c.shapes[p.c] = (c.shapes[p.c] || 0) + 1;
      if (p.k) c.colls[p.k] = (c.colls[p.k] || 0) + 1;
    });
    c.groups.sort(function (a, b) {
      var ia = GROUP_ORDER.indexOf(a), ib = GROUP_ORDER.indexOf(b);
      return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
    });
    return c;
  }

  function idle(fn) { (window.requestIdleCallback || function (f) { return setTimeout(f, 300); })(fn); }

  // What she already has: catalogue entries for the pieces in her bag,
  // or a minimal profile built from the bag line when a piece isn't eligible.
  function bagProfile(s) {
    var handles = (s && s.cartHandles || []).filter(Boolean);
    var lines = qa('.wv11-line:not(.wv11-line--gift)', drawer() || document);
    var pieces = handles.map(function (h) {
      var p = catalog && catalog.byHandle[h];
      if (p) return p;
      var line = lines.filter(function (l) { return l.dataset.handle === h; })[0];
      var title = line ? line.dataset.title : h;
      return { h: h, t: title, w: String(title).split(' ')[0].toLowerCase(), fam: [], s: '', g: '', r: [] };
    });
    var first = (s && s.firstHandle && pieces.filter(function (p) { return p.h === s.firstHandle; })[0]) || pieces[pieces.length - 1] || null;
    return { pieces: pieces, first: first, types: pieces.map(function (p) { return p.g; }).filter(Boolean), handles: handles };
  }

  // Suggestion order: her own set first (same family / same name),
  // then the same stone, your manual complementary picks, then the rest.
  // The same type she already has is welcome too (one Royale, one Mini).
  function score(p, prof) {
    var a = prof.first;
    var sc = 0;
    if (!a) return 0;
    prof.pieces.forEach(function (b) { if ((b.r || []).indexOf(p.h) >= 0) sc += 6; });
    var shared = (p.fam || []).filter(function (id) { return (a.fam || []).indexOf(id) >= 0; }).length;
    sc += Math.min(shared, 2) * 4;
    if (a.w && p.w === a.w) sc += 3;
    if (a.s && p.s && p.s === a.s) sc += 3;
    return sc;
  }

  function ranked(s) {
    if (!catalog) return [];
    var prof = bagProfile(s);
    return catalog.products
      .filter(function (p) { return prof.handles.indexOf(p.h) < 0; })
      .map(function (p, i) { return { p: p, sc: score(p, prof), i: i }; })
      .sort(function (x, y) { return (y.sc - x.sc) || (x.i - y.i); })
      .map(function (x) { return x.p; });
  }

  function suggestion(s) { return ranked(s)[0] || null; }

  function loadProduct(handle) {
    if (products[handle]) return Promise.resolve(products[handle]);
    return fetch(ROOT + 'products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (p) { products[handle] = p; return p; });
  }

  function priv(cents, s) { return s && s.live ? Math.round(cents * (100 - s.percent) / 100) : cents; }
  function priceHtml(cents, s) {
    if (!s || !s.live) return '<span class="wv11-price">' + money(cents, s && s.moneyFormat) + '</span>';
    return '<span class="wv11-price"><s>' + money(cents, s.moneyFormat) + '</s>' + money(priv(cents, s), s.moneyFormat) + '<span class="wv11-off">' + s.percent + '% off</span></span>';
  }

  function optName(o) { return typeof o === 'string' ? o : (o && o.name) || ''; }
  function isSize(o) { return /size/i.test(optName(o)); }
  function isColour(o) { return /colou?r|metal/i.test(optName(o)); }
  function isCustom(v) { return /made to order|custom/i.test(String(v)); }
  // Ring sizes in her system (V35): UK, US or EU, the same choice as the
  // product page (womuse-sizes.js saves it as wv20-ring-system). The UK opens
  // on UK, Europe on EU, everywhere else on US. The sizes come from Content >
  // WOMUSE Ring Size (sent with the catalogue); the buttons still choose the
  // piece's own US sizes, matched by inside circumference.
  var RS_KEY = 'wv20-ring-system', RINGS = null, RMAP = {};
  var EU_C = ['AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE','NO','CH','IS','LI'];
  function ringSys() {
    var v = null; try { v = localStorage.getItem(RS_KEY); } catch (e) {}
    if (v === 'UK' || v === 'US' || v === 'EU') return v;
    var c = (window.Shopify && Shopify.country) || '';
    return c === 'GB' ? 'UK' : (EU_C.indexOf(c) > -1 ? 'EU' : 'US');
  }
  function setRingSys(v) { try { localStorage.setItem(RS_KEY, v); } catch (e) {} RMAP = {}; }
  function setRings(list) {
    RINGS = { UK: [], US: [], EU: [] }; RMAP = {};
    list.forEach(function (r) { if (RINGS[r[0]] && isFinite(r[2])) RINGS[r[0]].push({ l: String(r[1]), mm: Number(r[2]) }); });
    Object.keys(RINGS).forEach(function (k) { RINGS[k].sort(function (a, b) { return a.mm - b.mm; }); });
  }
  function nearestRing(list, mm) {
    var best = null;
    list.forEach(function (x) { var dd = Math.abs(x.mm - mm); if (!best || dd < best.d - 1e-9 || (Math.abs(dd - best.d) < 1e-9 && x.mm > best.x.mm)) best = { x: x, d: dd }; });
    return best ? best.x : null;
  }
  function usRing(us) { return RINGS && RINGS.US.filter(function (x) { return x.l === String(us); })[0]; }
  // Her system's size for one of our US sizes (the same matching as the product page)
  function ringIn(sys, us) {
    var u = usRing(us); if (!u) return null;
    if (sys === 'US') return u.l;
    var cand = RINGS[sys].filter(function (x) { var n = nearestRing(RINGS.US, x.mm); return n && n.l === u.l; });
    var hit = cand.length ? nearestRing(cand, u.mm) : nearestRing(RINGS[sys], u.mm);
    return hit ? hit.l : null;
  }
  function ringMap() {
    var sys = ringSys(); if (sys === 'US') return null;
    if (RINGS) {
      if (!RMAP[sys]) { var map = {}; RINGS.US.forEach(function (x) { var l = ringIn(sys, x.l); if (l) map[x.l] = l; }); RMAP[sys] = { system: sys, map: map }; }
      return RMAP[sys];
    }
    try { var m = JSON.parse(localStorage.getItem('wv20-ring-map')); return m && m.system === sys ? m : null; } catch (e) { return null; }
  }
  function ringLabel(o, val) { var m = /ring/i.test(optName(o)) && ringMap(); return m && m.map[val] ? m.map[val] + ' (' + m.system + ')' : val; }
  function isRing(o) { return isSize(o) && /ring/i.test(optName(o)); }
  // The UK · US · EU switch (same look as the product page)
  function ringSwitch() {
    var sys = ringSys();
    return '<span class="wv20-sw wv11-ringsw" role="group" aria-label="Ring size system">' + ['UK', 'US', 'EU'].map(function (k) {
      return '<button type="button" data-wv11-act="ring-sys" data-sys="' + k + '" aria-pressed="' + (k === sys) + '">' + k + '</button>';
    }).join('') + '</span>';
  }
  // A size button's words: her size, with the US size small underneath
  function ringBtn(o, val) {
    var m = isRing(o) && ringMap();
    return m && m.map[val] ? esc(m.map[val]) + '<small class="wv20-us">US ' + esc(val) + '</small>' : esc(val);
  }
  function ringPlaceholder() {
    var sys = ringSys();
    return sys === 'UK' ? 'Your UK size, for example K½' : sys === 'EU' ? 'Your EU size, for example 51' : 'Your size, for example 7.25';
  }
  function mmTxt(mm) { var r = Math.round(mm * 100) / 100; return r % 1 === 0 ? r.toFixed(1) : String(r); }
  // Custom size note, as on the product page: "US 5.25 · 50.0 mm (chosen as UK K)"
  function customNote(o, val) {
    if (!/ring/i.test(optName(o))) return val;
    var sys = ringSys(), raw = String(val).trim();
    if (RINGS && sys !== 'US') {
      var norm = function (t) { return String(t).toUpperCase().replace(/\s+/g, '').replace(/1\/2|\.5/g, '½'); };
      var hit = RINGS[sys].filter(function (x) { return norm(x.l) === norm(raw); })[0];
      if (hit) { var u = nearestRing(RINGS.US, hit.mm); return 'US ' + u.l + ' · ' + mmTxt(hit.mm) + ' mm (chosen as ' + sys + ' ' + hit.l + ')'; }
      return sys + ' ' + raw;
    }
    var n = String(parseFloat(raw.replace(',', '.')));
    var u2 = usRing(n);
    if (u2) return 'US ' + n + ' · ' + mmTxt(u2.mm) + ' mm';
    var m; try { m = JSON.parse(localStorage.getItem('wv20-ring-map')); } catch (e) { m = null; }
    var mm = m && m.usMM && m.usMM[n];
    return mm ? 'US ' + n + ' · ' + (mm % 1 === 0 ? mm.toFixed(1) : mm) + ' mm' : 'US ' + n;
  }
  function paintRingPills() {
    var m = ringMap();
    qa('.wv11-line .wv11-pill[data-wv11-opt], .wv11-line .wv11-line__opt-txt, .wv11-line .wv11-sumv').forEach(function (b) {
      var al = (b.getAttribute('aria-label') || '').toLowerCase();
      if (b.classList.contains('wv11-pill') && al.indexOf('ring') < 0) return;
      if (b.classList.contains('wv11-sumv') && !b.classList.contains('wv11-sumv--ring')) return;
      var tn = b.firstChild; if (!tn || tn.nodeType !== 3) return;
      // remember the US size the first time, so switching UK · US · EU can repaint it
      // (a plain "Size 5.5" is always the US size as the bag wrote it)
      var mt = tn.textContent.match(/^Size (\S+)$/), us = mt ? mt[1] : b.getAttribute('data-wv11-us');
      if (!us) return;
      b.setAttribute('data-wv11-us', us);
      var want = 'Size ' + (m && m.map[us] ? m.map[us] + ' (' + m.system + ')' : us);
      if (tn.textContent !== want) tn.textContent = want;
    });
  }
  function uniq(a) { return a.filter(function (x, i) { return x != null && a.indexOf(x) === i; }); }
  function swatch(v) {
    var t = String(v).toLowerCase();
    if (t.indexOf('rose') >= 0) return '#B76E79';
    if (t.indexOf('silver') >= 0 || t.indexOf('white') >= 0) return '#D3D3D3';
    if (t.indexOf('gold') >= 0) return '#D49A06';
    return '#CFCFCF';
  }
  function img600(src) { return String(src || '').replace(/^\/\//, 'https://'); }

  // Titles without the closing type word (Ring, Earrings, Bangle...), as on collection pages
  function shortTitle(t) { return String(t || '').replace(/\s+(Rings?|Necklaces?|Earrings?|Bracelets?|Bangles?|Charms?|Pendants?|Anklets?|Hoops)$/i, ''); }

  // Photo with the product page arrow (bottom right) and progress line on the bottom edge
  function slideHtml(imgs, opts) {
    opts = opts || {};
    imgs = (imgs || []).filter(Boolean);
    var n = Math.max(1, imgs.length);
    var cls = 'wv11-slide' + (opts.small ? ' wv11-slide--sm' : '') + (opts.full ? ' wv11-slide--full' : '');
    var h = '<div class="' + cls + '" data-wv11-slide data-imgs="' + esc(JSON.stringify(imgs)) + '" data-i="0">';
    h += '<img src="' + esc(imgs[0] || '') + '" alt=""' + (opts.lazy ? ' loading="lazy"' : '') + (opts.act ? ' data-wv11-act="' + opts.act + '" data-handle="' + esc(opts.handle) + '"' : '') + '>';
    if (opts.tag) h += '<span class="wv11-chosen">' + esc(opts.tag) + '</span>';
    if (opts.fav) h += heartBtn(opts.fav, opts.title || '');
    if (n > 1) h += '<button type="button" class="wv11-slide__prev" data-wv11-act="slide-prev" aria-label="Previous photo" hidden>' + ICON.prev + '</button><button type="button" class="wv11-slide__next" data-wv11-act="slide-next" aria-label="Next photo">' + ICON.next + '</button>';
    h += '<span class="wv11-slide__bar" aria-hidden="true"><span style="width: ' + (100 / n) + '%"></span></span>';
    return h + '</div>';
  }

  // Suggested piece: square photos side by side, as many as fit
  // (three on a wide bag, two on a narrower one, one on a phone)
  function galleryHtml(imgs, handle, title, extraCls) {
    imgs = (imgs || []).filter(Boolean).slice(0, 6);
    var h = '<div class="wv11-gallery' + (extraCls ? ' ' + extraCls : '') + '" data-wv11-gallery-wrap><div class="wv11-gallery__track" data-wv11-gallery>';
    h += imgs.map(function (src) { return '<span class="wv11-gallery__item"><img src="' + esc(src) + '" alt="" loading="lazy"></span>'; }).join('');
    h += '</div>' + heartBtn(handle, title || '');
    h += '<button type="button" class="wv11-slide__prev" data-wv11-act="gal-prev" aria-label="Previous photo" hidden>' + ICON.prev + '</button>';
    h += '<button type="button" class="wv11-slide__next" data-wv11-act="gal-next" aria-label="Next photo">' + ICON.next + '</button>';
    h += '<span class="wv11-slide__bar" aria-hidden="true"><span></span></span>';
    return h + '</div>';
  }
  function galleryBar(track) {
    var wrap = track.closest('[data-wv11-gallery-wrap]'); if (!wrap) return;
    var bar = q('.wv11-slide__bar span', wrap), next = q('.wv11-slide__next', wrap), prev = q('.wv11-slide__prev', wrap);
    var sw = track.scrollWidth || 1, cw = track.clientWidth;
    var all = sw <= cw + 2;
    if (next) next.hidden = all || track.scrollLeft + cw >= sw - 4;
    if (prev) prev.hidden = all || track.scrollLeft <= 4;
    if (bar) { bar.parentNode.hidden = all; bar.style.width = (cw / sw * 100) + '%'; bar.style.transform = 'translateX(' + (track.scrollLeft / cw * 100) + '%)'; }
  }

  // Our own dropdown: a pill that opens a short list right under it
  function ddHtml(act, values, current, label, extra) {
    if (!values || values.length < 2) return '';
    return '<span class="wv11-dd" data-wv11-dd><button type="button" class="wv11-pill" data-wv11-dd-toggle aria-haspopup="listbox" aria-expanded="false" aria-label="' + esc(label) + ': ' + esc(current) + '">' + esc(current) + ICON.chev + '</button>' +
      '<span class="wv11-dd__list" role="listbox" hidden>' + values.map(function (v) {
        var val = typeof v === 'object' ? v.value : v, txt = typeof v === 'object' ? v.label : v;
        return '<button type="button" role="option" data-wv11-act="' + act + '" data-value="' + esc(val) + '"' + (extra ? ' ' + extra(v) : '') + ' aria-selected="' + (String(val) === String(current) || txt === current) + '">' + esc(txt) + '</button>';
      }).join('') + '</span></span>';
  }

  /* ---------------- 5.4 private selection + gift ---------------- */

  function renderRewards() {
    var d = drawer(); if (!d) return;
    var mount = q('[data-wv11-rewards]', d); if (!mount) return;
    var s = readState(); if (!s) return;
    var html = '';

    // Selection: while there is a paid piece and no second piece yet.
    // When the promotion is off it stays, without any percentage wording.
    var teaser = !s.hasSelection && s.paidUnits >= 1;
    if (teaser) {
      html += ui.sel === 'open' ? selectorHtml(s) : teaserHtml(s);
    }

    // Gift
    if (s.giftThreshold > 0 && (s.gifts || []).length && !s.giftKey) {
      if (s.giftReady) html += ui.altOpen ? giftAltsHtml(s) : giftOfferHtml(s);
      else html += giftBarHtml(s, !teaser);
    }

    // Keep the bag exactly where she was while the offer redraws (choosing a gift,
    // changing its metal): remember the scroll and the button she pressed.
    var scroller = mount.closest('.quick-cart__form') || mount.closest('.quick-cart__items');
    var keepTop = scroller ? scroller.scrollTop : 0;
    var fa = document.activeElement && mount.contains(document.activeElement) ? document.activeElement : null;
    var faKey = fa ? [fa.getAttribute('data-wv11-act'), fa.getAttribute('data-handle') || fa.getAttribute('data-variant') || fa.getAttribute('data-value') || ''] : null;
    mount.innerHTML = html;
    mount.dataset.wv11Done = '1';
    if (faKey && faKey[0]) {
      var again = qa('[data-wv11-act="' + faKey[0] + '"]', mount).filter(function (x) { return !faKey[1] || x.getAttribute('data-handle') === faKey[1] || x.getAttribute('data-variant') === faKey[1] || x.getAttribute('data-value') === faKey[1]; })[0];
      if (again) { try { again.focus({ preventScroll: true }); } catch (er) {} }
    }
    if (scroller && scroller.scrollTop !== keepTop) scroller.scrollTop = keepTop;
    if (scroller) requestAnimationFrame(function () { if (Math.abs(scroller.scrollTop - keepTop) > 2 && keepTop <= scroller.scrollHeight - scroller.clientHeight) scroller.scrollTop = keepTop; });
    qa('[data-wv11-gallery]', mount).forEach(function (t) { requestAnimationFrame(function () { galleryBar(t); }); });
    // Opening the selection: bring it to the top of the bag so the whole photo shows
    var selBox = ui.revealSel && catalog && q('.wv11-selector', mount);
    if (selBox && scroller) {
      ui.revealSel = false;
      requestAnimationFrame(function () {
        var top = scroller.scrollTop + selBox.getBoundingClientRect().top - scroller.getBoundingClientRect().top - 10;
        scroller.scrollTo({ top: Math.max(0, top), behavior: REDUCED ? 'auto' : 'smooth' });
      });
    }

    if (!catalog) {
      idle(function () {
        loadCatalog(s).then(function () {
          if (!mount.isConnected) return;
          if (ui.sel === 'open') { renderRewards(); return; }
          var img = q('[data-wv11-teaser-img]', mount);
          var A = suggestion(s);
          if (img && A && A.i) img.src = A.i;
        });
      });
    }
  }

  function teaserHtml(s) {
    var A = catalog ? suggestion(s) : null;
    var first = q('.wv11-line:not(.wv11-line--gift) img', drawer());
    var src = A ? A.i : (first ? first.currentSrc || first.src : '');
    var head = s.live ? s.headline : 'Pieces chosen to go with yours.';
    var sub = s.live ? fill(s.description, s) : '';
    var cta = s.live ? s.buttonLabel : 'See your selection';
    return '<button type="button" class="wv11-offer wv11-teaser" data-wv11-act="sel-open" aria-label="' + esc(cta) + '">' +
      '<span class="wv11-teaser__media"><span class="wv11-teaser__clip"><img data-wv11-teaser-img src="' + esc(src) + '" alt=""></span><span class="wv11-lock">' + ICON.lock + '</span></span>' +
      '<span class="wv11-teaser__text"><span class="wv11-eb">' + esc(s.text.eyebrow) + '</span>' +
      '<span class="wv11-teaser__head">' + esc(head) + '</span>' +
      (sub ? '<span class="wv11-teaser__sub">' + esc(sub) + '</span>' : '') +
      '<span class="wv11-teaser__cta">' + esc(cta) + '</span>' +
      (s.live && s.endLabel ? '<span class="wv11-teaser__end">Offer ends ' + esc(s.endLabel) + '</span>' : '') +
      '</span><span class="wv11-circle wv11-circle--lg wv11-press" aria-hidden="true">' + ICON.arrow + '</span></button>';
  }

  function typeWord(prof) {
    var g = prof.first && prof.first.g;
    var map = { Rings: 'ring', Necklaces: 'necklace', Earrings: 'earrings', Bracelets: 'bracelet', Charms: 'charm' };
    return map[g] || 'piece';
  }

  function metalVariant(p, metal) {
    if (!p) return null;
    var ci = p.options.findIndex ? p.options.findIndex(isColour) : -1;
    var avail = p.variants.filter(function (v) { return v.available; });
    if (ci >= 0 && metal) { var m = avail.filter(function (v) { return v.options[ci] === metal; })[0]; if (m) return m; }
    return avail[0] || null;
  }
  function bagMetal() {
    var first = q('.wv11-line:not(.wv11-line--gift) .wv11-line__opts', drawer());
    var t = first ? first.textContent.toLowerCase() : '';
    if (t.indexOf('rose') >= 0) return 'rose';
    if (t.indexOf('silver') >= 0) return 'silver';
    if (t.indexOf('gold') >= 0) return 'gold';
    return '';
  }

  function selectorHtml(s) {
    var head = '<div class="wv11-selector__head"><span class="wv11-eb">' + esc(s.text.eyebrow) + '</span><button type="button" class="wv11-x" data-wv11-act="sel-close" aria-label="Close selection">' + ICON.close + '</button></div>';
    if (!catalog) { loadCatalog(s); return '<section class="wv11-offer wv11-selector">' + head + '<p class="wv11-loading">Preparing your selection…</p></section>'; }
    var all = ranked(s), A = all[0] || null;
    if (!A) return '<section class="wv11-offer wv11-selector">' + head + '<p class="wv11-loading">Your selection is being updated. Please try again shortly.</p></section>';
    var prof = bagProfile(s);
    var p = products[A.h];
    if (!p) loadProduct(A.h).then(function () { if (ui.sel === 'open') renderRewards(); });
    var h = '<section class="wv11-offer wv11-selector" aria-label="' + esc(s.text.eyebrow) + '">' + head;
    h += '<div><div class="wv11-selector__title">' + esc(s.text.optionA) + '</div><div class="wv11-selector__sub">' + (all.length > 1 ? all.length + ' pieces chosen' : 'Chosen') + ' to go with your ' + typeWord(prof) + '</div></div>';
    var selImgs = A.imgs;
    var mv = p && ui.selMetal ? metalVariant(p, ui.selMetal) : null;
    if (mv && mv.featured_image && mv.featured_image.src) {
      var msrc = img600(mv.featured_image.src) + (String(mv.featured_image.src).indexOf('?') >= 0 ? '&' : '?') + 'width=600';
      var file = function (u) { return String(u).split('?')[0].split('/').pop(); };
      selImgs = [msrc].concat((A.imgs || []).filter(function (u) { return file(u) !== file(msrc); }));
    }
    h += galleryHtml(selImgs, A.h, A.t);
    h += '<div><div class="wv11-selector__name">' + esc(shortTitle(A.t)) + '</div>' + priceHtml(A.p, s) + '</div>';
    var needsSize = p && p.options.some(isSize);
    var ci = p ? p.options.findIndex(isColour) : -1;
    var metals = p && ci >= 0 ? uniq(p.variants.filter(function (v) { return v.available; }).map(function (v) { return v.options[ci]; })) : [];
    if (p && !ui.selMetal) { var bm = bagMetal(); ui.selMetal = metals.filter(function (m) { return bm && m.toLowerCase().indexOf(bm) >= 0; })[0] || metals[0] || null; }
    var v = metalVariant(p, ui.selMetal);
    h += '<div class="wv11-row">';
    if (metals.length > 1) h += ddHtml('sel-metal', metals, ui.selMetal, 'Metal');
    if (!p) h += '<button type="button" class="wv11-btn2" disabled>Loading…</button>';
    else if (needsSize) h += '<button type="button" class="wv11-btn2" data-wv11-act="detail" data-handle="' + esc(A.h) + '">Choose your size</button>';
    else if (v) h += '<button type="button" class="wv11-btn2" data-wv11-act="sel-add" data-variant="' + v.id + '">Add to bag · ' + money(priv(v.price, s), s.moneyFormat) + '</button>';
    else h += '<button type="button" class="wv11-btn2" disabled>Not available</button>';
    h += '</div>';
    h += '<div class="wv11-or">or choose your own</div>';
    h += '<div class="wv11-row"><button type="button" class="wv11-choice" data-wv11-act="browse" data-tab="fav">' + ICON.heartFull + 'Favourites</button><button type="button" class="wv11-choice" data-wv11-act="browse">' + ICON.search + 'Browse all</button></div>';
    return h + '</section>';
  }

  function giftBarHtml(s, solo) {
    var pct = Math.max(0, Math.min(100, Math.round(s.paidTotal / s.giftThreshold * 100)));
    var near = pct >= 85;
    var eb = String(s.text.giftEyebrow || ''), cut = eb.lastIndexOf(' ');
    var ebHtml = cut > 0 ? esc(eb.slice(0, cut)) + '<br class="wv11-mbr"><span class="wv11-dbr"> </span>' + esc(eb.slice(cut + 1)) : esc(eb);
    return '<section class="wv11-offer wv11-giftbar' + (solo ? ' wv11-giftbar--solo' : '') + '" aria-label="' + esc(eb) + '"><span class="wv11-giftbar__icon">' + ICON.gift + '</span>' +
      '<span class="wv11-giftbar__text"><span class="wv11-giftbar__row"><span class="wv11-eb">' + ebHtml + '</span><span class="wv11-togo"><span class="wv11-togo__amt">' + money(Math.max(0, s.giftThreshold - s.paidTotal), s.moneyFormat) + '</span> <span class="wv11-togo__lbl">to go</span></span></span>' +
      '<span class="wv11-gtrk" aria-hidden="true" data-wv11-gtrk style="--p:' + pct + '"><span class="wv11-gtrk__ln"></span><span class="wv11-gtrk__fill"></span><span class="wv11-gtrk__dot' + (near ? ' is-near' : '') + '"></span><span class="wv11-gtrk__goal' + (near ? ' is-near' : '') + '">' + ICON.giftSm + '</span></span>' +
      '<span class="wv11-giftbar__note">A complimentary piece when your bag reaches ' + money(s.giftThreshold, s.moneyFormat) + '.</span></span></section>';
  }

  // Her metal: match the gift to the metal of her first piece when possible.
  function giftVariant(g) {
    var avail = g.variants.filter(function (v) { return v.available; });
    if (!avail.length) return null;
    if (ui.giftVariant) { var picked = avail.filter(function (v) { return v.id === ui.giftVariant; })[0]; if (picked) return picked; }
    var bm = bagMetal();
    return avail.filter(function (v) { return bm && v.title.toLowerCase().indexOf(bm) >= 0; })[0] || avail[0];
  }
  function giftMetals(g, v) {
    var avail = g.variants.filter(function (x) { return x.available; });
    if (avail.length < 2) return '';
    return ddHtml('gift-variant', avail.map(function (x) { return { value: x.id, label: x.title }; }), v.title, 'Metal', function (o) { return 'data-variant="' + o.value + '"'; });
  }
  function currentGift(s) { return s.gifts.filter(function (g) { return g.handle === ui.giftPick; })[0] || s.gifts[0]; }

  // Small pressed-in magnifier on the gift photo: invites the tap
  var ZOOM_IC = '<span class="wv11-zoomable__ic" aria-hidden="true"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="11" cy="11" r="6.5"/><path d="M16 16l4.5 4.5M11 8.5v5M8.5 11h5"/></svg></span>';
  function giftOfferHtml(s) {
    var g = currentGift(s);
    var v = giftVariant(g); if (!v) return '';
    var h = '<section class="wv11-offer wv11-giftcard" aria-label="' + esc(s.text.giftEyebrow) + '"><span class="wv11-eb">' + esc(s.text.giftEyebrow) + '</span>' +
      '<div class="wv11-giftcard__row"><button type="button" class="wv11-zoomable" data-wv11-zoom="' + esc(g.handle) + '" data-variant="' + v.id + '" aria-label="See ' + esc(g.title) + ' larger"><img src="' + esc(v.image || g.image) + '" alt="">' + ZOOM_IC + '</button><div><div class="wv11-giftcard__name">' + esc(g.title) + '</div><div class="wv11-giftcard__val"><s>' + money(g.price, s.moneyFormat) + '</s>  Complimentary</div></div></div>';
    h += '<div class="wv11-row">' + giftMetals(g, v) + '<button type="button" class="wv11-btn2" data-wv11-act="gift-accept" data-variant="' + v.id + '">' + esc(s.text.giftAccept) + '</button></div>';
    if (s.gifts.length > 1) h += '<button type="button" class="wv11-link" style="align-self:flex-start;color:var(--wv11-muted);font-size:13px" data-wv11-act="gift-alts">' + esc(s.text.giftExplore) + '</button>';
    return h + '</section>';
  }

  function giftAltsHtml(s) {
    var cur = currentGift(s);
    var h = '<section class="wv11-offer wv11-giftcard" aria-label="' + esc(s.text.giftEyebrow) + '"><span class="wv11-eb">' + esc(s.text.giftEyebrow) + '</span><span style="font-size:15px">Choose your gift</span>';
    s.gifts.forEach(function (g) {
      var on = g.handle === cur.handle;
      var v = giftVariant(g);
      h += '<div class="wv11-giftopt' + (on ? ' is-on' : '') + '"><button type="button" class="wv11-giftopt__head" data-wv11-act="gift-pick" data-handle="' + esc(g.handle) + '" aria-pressed="' + on + '"><span class="wv11-radio"></span><span class="wv11-zoomable" data-wv11-zoom="' + esc(g.handle) + '" data-variant="' + (v ? v.id : '') + '" role="button" tabindex="0" aria-label="See ' + esc(g.title) + ' larger"><img src="' + esc((v && v.image) || g.image) + '" alt="">' + ZOOM_IC + '</span><span style="flex:1;min-width:0;display:flex;flex-direction:column;gap:2px"><span style="font-size:15px">' + esc(g.title) + '</span><span class="wv11-giftcard__val" style="font-size:13px"><s>' + money(g.price, s.moneyFormat) + '</s>  Complimentary</span></span></button>';
      if (on && v) h += '<div class="wv11-giftopt__body">' + giftMetals(g, v) + (bagMetal() && !ui.giftVariant ? '<span>Matched to your ' + typeWord(bagProfile(s)) + '</span>' : '') + '</div>';
      h += '</div>';
    });
    var cv = giftVariant(cur);
    h += '<button type="button" class="wv11-btn2" style="flex-grow:0;height:44px" data-wv11-act="gift-accept" data-variant="' + (cv ? cv.id : '') + '">' + esc(s.text.giftAccept) + '</button>';
    h += '<button type="button" class="wv11-link" style="align-self:center;color:var(--wv11-muted);font-size:13px" data-wv11-act="gift-back">Back to our suggestion</button>';
    return h + '</section>';
  }

  /* ---------------- 5.5 gift upkeep, single mark, undo, footer ---------------- */

  var giftBusy = false;
  function keepGiftHonest() {
    var s = readState(); if (!s || giftBusy) return;
    if (s.giftKey && (!(s.giftThreshold > 0) || !s.giftReady)) {
      giftBusy = true;
      getCart().then(function (cart) {
        var line = cart.items.filter(function (i) { return i.key === s.giftKey; })[0];
        if (line && s.giftThreshold > 0) store(ASIDE_KEY, { id: line.variant_id });
        return post('cart/change.js', { id: s.giftKey, quantity: 0 });
      }).then(refresh).catch(function (e) { console.error('[WOMUSE bag] gift', e); }).then(function () { giftBusy = false; });
      return;
    }
    var aside = load(ASIDE_KEY);
    if (aside && !s.giftKey && s.giftReady) {
      giftBusy = true;
      store(ASIDE_KEY, null);
      post('cart/add.js', { items: [{ id: aside.id, quantity: 1, properties: { _womuse_gift: '1' } }] })
        .then(refresh).catch(function (e) { console.error('[WOMUSE bag] gift', e); }).then(function () { giftBusy = false; });
    }
  }

  // Only one second piece: if two lines carry the mark (her first piece was
  // removed and she then chose another), the newest keeps it.
  var markBusy = false;
  function keepOneMark() {
    var s = readState(); if (!s || markBusy) return;
    var keys = (s.flagKeys || []).filter(Boolean);
    if (keys.length < 2) return;
    markBusy = true;
    getCart().then(function (cart) {
      var chain = Promise.resolve();
      keys.slice(1).forEach(function (key) {
        var item = cart.items.filter(function (i) { return i.key === key; })[0];
        if (!item) return;
        var props = Object.assign({}, item.properties || {});
        props._womuse_selection = ''; // Shopify ignores an empty object; a blank value clears the mark
        chain = chain.then(function () { return post('cart/change.js', { id: key, quantity: item.quantity, properties: props }); });
      });
      return chain;
    }).then(refresh).catch(function (e) { console.error('[WOMUSE bag] mark', e); }).then(function () { markBusy = false; });
  }

  var undoTimer = 0;
  function renderUndo() {
    var d = drawer(); if (!d) return;
    var el = q('[data-wv11-undo]', d);
    // The last piece was removed (the bag is empty): Undo still shows, at the top
    var empty = !el && q('.quick-cart__empty-state', d);
    if (empty && load(UNDO_KEY)) { el = document.createElement('div'); el.className = 'wv11-undo wv11-undo--empty'; el.setAttribute('data-wv11-undo', ''); empty.insertBefore(el, empty.firstChild); }
    if (!el) return;
    var u = load(UNDO_KEY), s = readState(), aside = load(ASIDE_KEY);
    // "… removed · Undo" sits exactly where the piece was
    var lines = q('.wv11-lines', d);
    if (u && lines && u.pos != null && u.pos >= 0) {
      var at = qa(':scope > :not([data-wv11-undo])', lines)[u.pos] || null;
      if (el.parentNode !== lines || el.nextSibling !== at) lines.insertBefore(el, at);
    } else if (lines && el.parentNode === lines) {
      lines.parentNode.insertBefore(el, lines.nextSibling);
    }
    clearTimeout(undoTimer);
    var left = u ? UNDO_MS - (Date.now() - u.ts) : 0;
    if (u && left > 0) {
      el.innerHTML = '<span style="min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">' + esc(u.title) + ' removed</span><button type="button" class="wv11-link" data-wv11-act="undo">Undo</button>';
      el.hidden = false; el.classList.remove('is-leaving');
      undoTimer = setTimeout(function () {
        el.classList.add('is-leaving');
        setTimeout(function () { store(UNDO_KEY, null); el.hidden = true; el.innerHTML = ''; el.classList.remove('is-leaving'); }, 400);
      }, left);
    } else if (aside && s && !s.giftKey && !s.giftReady && s.giftThreshold > 0) {
      el.innerHTML = '<span>Your gift is set aside until your bag reaches ' + money(s.giftThreshold, s.moneyFormat) + '.</span>';
      el.hidden = false;
    } else { store(UNDO_KEY, null); el.hidden = true; el.innerHTML = ''; }
  }

  function restoreFooter() {
    var d = drawer(); if (!d) return;
    var sum = q('[data-wv11-summary]', d), tog = q('[data-wv11-total-toggle]', d);
    if (sum && tog) {
      sum.hidden = !ui.details;
      tog.setAttribute('aria-expanded', String(ui.details));
      var l = q('[data-wv11-toggle-label]', tog); if (l) l.textContent = ui.details ? 'Hide details' : 'Show details';
    }
    var form = q('[data-wv11-code-form]', d), ct = q('[data-wv11-code-toggle]', d);
    if (form && ct) { form.hidden = !ui.codeOpen; ct.setAttribute('aria-expanded', String(ui.codeOpen)); }
  }

  // Discount notes stay 5 seconds, then the box is clean again
  var codeNoteT = 0;
  function codeNote(fb, text) {
    if (!fb) return;
    fb.hidden = false; fb.textContent = text;
    clearTimeout(codeNoteT);
    codeNoteT = setTimeout(clearCodeNote, 5000);
  }
  function clearCodeNote() {
    clearTimeout(codeNoteT);
    qa('[data-wv11-code-feedback]').forEach(function (fb) { fb.hidden = true; fb.textContent = ''; });
  }

  // Code tags like Shopify checkout: every code she entered, with an x.
  // A code that no longer applies to this bag stays, struck through.
  function renderChips() {
    var d = drawer(); if (!d) return;
    var box = q('[data-wv11-chips]', d); if (!box) return;
    getCart().then(function (cart) {
      if (!box.isConnected) return;
      var codes = cart.discount_codes || [];
      box.innerHTML = codes.map(function (c) {
        return '<span class="wv11-chip' + (c.applicable ? '' : ' wv11-chip--off') + '">' + esc(String(c.code).toUpperCase()) +
          '<button type="button" aria-label="Remove ' + esc(c.code) + '" data-wv11-code-remove="' + esc(c.code) + '">' + ICON.close + '</button></span>';
      }).join('');
      var off = codes.filter(function (c) { return !c.applicable; });
      var fb = q('[data-wv11-code-feedback]', d);
      var sig = off.map(function (c) { return c.code; }).join(',');
      if (fb && off.length && ui.codeNoteSig !== sig) { ui.codeNoteSig = sig; codeNote(fb, off.map(function (c) { return String(c.code).toUpperCase(); }).join(', ') + (off.length > 1 ? ' don’t' : ' doesn’t') + ' apply to this bag.'); }
    }).catch(function () {});
  }

  /* ---------------- 5.6 your own selection + piece chosen ---------------- */

  // With an empty bag there is no bag state yet: plain prices, no offer wording
  function panelState() {
    var s = readState(); if (s) return s;
    var g = readGlobal() || {};
    return { live: false, percent: g.percent || 0, moneyFormat: g.moneyFormat, cartHandles: [], hasSelection: true, paidUnits: 0, ringSize: '', text: { eyebrow: 'Your favourites' } };
  }

  function openPanel(view, handle, opts) {
    var s = panelState();
    opts = opts || {};
    var prev = ui.panel || {};
    ui.panel = {
      view: view, handle: handle || null, from: prev.view || null,
      group: opts.group || prev.group || 'all', stone: prev.stone || 'all', shape: prev.shape || 'all', coll: prev.coll || 'all', q: prev.q || '',
      favOnly: opts.fav != null ? !!opts.fav : !!prev.favOnly, sort: prev.sort || 'chosen', allCats: false, open: null, sheet: false,
      sel: {}, custom: '', sizeOpen: true, listTop: prev.listTop || 0
    };
    renderPanel();
    var ready = loadCatalog(s);
    if (view === 'detail' && handle) ready = Promise.all([ready, loadProduct(handle)]).then(function () { preselect(products[handle], s); });
    ready.then(function () {
      renderPanel();
      if (opts.focusSearch) { var i = q('[data-wv11-search]', drawer()); if (i) i.focus(); }
    }).catch(function (e) { console.error('[WOMUSE bag] panel', e); renderPanel(); });
  }
  function closePanel() { ui.panel = null; renderPanel(); }

  function preselect(p, s) {
    if (!p || !ui.panel) return;
    var sel = {};
    p.options.forEach(function (o, i) {
      var vals = uniq(p.variants.map(function (v) { return v.options[i]; }));
      if (vals.length === 1) sel[i] = vals[0];
    });
    var bm = bagMetal();
    p.options.forEach(function (o, i) {
      if (sel[i] != null) return;
      var vals = uniq(p.variants.map(function (v) { return v.options[i]; }));
      if (isSize(o)) {
        // Her size from the ring already in her bag
        if (s && s.ringSize && vals.indexOf(s.ringSize) >= 0) sel[i] = s.ringSize;
        return;
      }
      var m = vals.filter(function (v) { return bm && String(v).toLowerCase().indexOf(bm) >= 0; })[0];
      if (m) sel[i] = m;
    });
    ui.panel.sel = sel;
  }

  function renderPanel() {
    var d = drawer(); if (!d) return;
    var el = q('[data-wv11-panel]', d); if (!el) return;
    var s = panelState();
    if (!ui.panel || !s) { el.hidden = true; el.innerHTML = ''; return; }
    el.hidden = false;
    var sc = q('[data-wv11-scroll]', el);
    var top = sc ? sc.scrollTop : 0;
    if (!catalog || (ui.panel.view === 'detail' && !products[ui.panel.handle])) {
      el.innerHTML = panelBar('Bag', 'panel-close', s) + '<div class="wv11-panel__scroll"><p class="wv11-loading">Loading…</p></div>';
      return;
    }
    el.innerHTML = ui.panel.view === 'detail' ? detailHtml(s) : listHtml(s);
    var sc2 = q('[data-wv11-scroll]', el);
    if (sc2 && ui.panel.view === 'list') { sc2.scrollTop = ui.panel.keepTop ? top : (ui.panel.listTop || 0); ui.panel.keepTop = false; ui.panel.lastY = sc2.scrollTop; onPanelScroll(sc2); }
    qa('[data-wv11-gallery]', el).forEach(function (t) { requestAnimationFrame(function () { galleryBar(t); }); });
  }

  // While she types: redraw everything in Browse except the search box itself,
  // so the keyboard keeps working normally (holding delete clears the word)
  function refreshList() {
    var el = q('[data-wv11-panel]', drawer()), s = panelState();
    var sc = el && q('[data-wv11-scroll]', el), pin = sc && q('.wv11-pin', sc);
    if (!s || !catalog || !pin || ui.panel.view !== 'list') return false;
    var tmp = document.createElement('div'); tmp.innerHTML = listHtml(s);
    var nsc = q('[data-wv11-scroll]', tmp), npin = nsc && q('.wv11-pin', nsc);
    if (!npin) return false;
    qa(':scope > :not(.wv11-search)', pin).forEach(function (x) { x.remove(); });
    qa(':scope > :not(.wv11-search)', npin).forEach(function (x) { pin.appendChild(x); });
    while (pin.nextSibling) sc.removeChild(pin.nextSibling);
    while (npin.nextSibling) sc.appendChild(npin.nextSibling);
    return true;
  }

  function panelBar(label, act, s) {
    return '<div class="wv11-panel__bar"><button type="button" class="wv11-panel__back" data-wv11-act="' + act + '">' + ICON.back + esc(label) + '</button><span class="wv11-panel__title wv11-eb">' + esc(s.text.eyebrow) + '</span></div>';
  }

  // Category is navigation (tabs); everything else is a filter (one bar).
  var FACETS = [
    { key: 'coll', title: 'Collection', field: 'k' },
    { key: 'stone', title: 'Stone', field: 's' },
    { key: 'shape', title: 'Stone shape', field: 'c' }
  ];
  var SORTS = [
    { v: 'chosen', l: 'Chosen for you' },
    { v: 'price-asc', l: 'Price: low to high' },
    { v: 'price-desc', l: 'Price: high to low' }
  ];

  function searchTerm() { return (ui.panel.q || '').trim().toLowerCase(); }
  function tabApplies() { return ui.panel.group !== 'all' && !(searchTerm() && ui.panel.allCats); }

  // Does a piece pass every choice she made, leaving one out (for counts)
  function passes(p, skip) {
    var P = ui.panel, term = searchTerm();
    if (skip !== 'group' && tabApplies() && p.g !== P.group) return false;
    if (skip !== 'fav' && P.favOnly && favs().indexOf(p.h) < 0) return false;
    if (skip !== 'stone') {
      if (P.stone === 'none' && p.s) return false;
      if (P.stone !== 'all' && P.stone !== 'none' && p.s !== P.stone) return false;
    }
    if (skip !== 'shape' && P.shape !== 'all' && p.c !== P.shape) return false;
    if (skip !== 'coll' && P.coll !== 'all' && p.k !== P.coll) return false;
    if (term && !term.split(/\s+/).every(function (w) { return (p.t + ' ' + p.g + ' ' + p.s + ' ' + (p.c || '') + ' ' + (p.k || '')).toLowerCase().indexOf(w) >= 0; })) return false;
    return true;
  }

  function filtered(s) {
    var base = ranked(s);
    var list = base.filter(function (p) { return passes(p); });
    // Chosen for you: Signature pieces first, then The perfect pair, then the rest
    if (ui.panel.sort === 'chosen' && !searchTerm()) {
      var pairs = []; bagProfile(s).pieces.forEach(function (b) { pairs = pairs.concat(b.r || []); });
      var rank = function (p) { return p.pr ? 0 : pairs.indexOf(p.h) >= 0 ? 1 : 2; };
      list = list.map(function (p, i) { return { p: p, i: i }; }).sort(function (a, b) { return (rank(a.p) - rank(b.p)) || (a.i - b.i); }).map(function (x) { return x.p; });
    }
    if (ui.panel.sort === 'price-asc') list = list.slice().sort(function (a, b) { return a.p - b.p; });
    if (ui.panel.sort === 'price-desc') list = list.slice().sort(function (a, b) { return b.p - a.p; });
    return { list: list, base: base, term: searchTerm() };
  }

  function facetCounts(base, f) {
    var c = {}, none = 0;
    base.forEach(function (p) {
      if (!passes(p, f.key)) return;
      if (p[f.field]) c[p[f.field]] = (c[p[f.field]] || 0) + 1; else none++;
    });
    return { c: c, none: none };
  }

  // After a tab change, drop any filter that no longer has pieces in that tab
  function tidyFilters(s) {
    var base = ranked(s);
    FACETS.forEach(function (f) {
      var cur = ui.panel[f.key]; if (cur === 'all') return;
      var fc = facetCounts(base, f);
      if (cur === 'none' ? !fc.none : !fc.c[cur]) ui.panel[f.key] = 'all';
    });
  }

  function optionBtn(key, value, label, count, on, extraCls) {
    return '<button type="button"' + (extraCls ? ' class="' + extraCls + '"' : '') + ' role="option" data-wv11-act="filter" data-key="' + key + '" data-value="' + esc(value) + '" aria-selected="' + on + '">' + esc(label) + (count != null ? '<span>' + count + '</span>' : '') + '</button>';
  }

  // One filter: Collection, Stone or Stone shape. Hidden when the tab has none.
  function facetDd(f, base) {
    var fc = facetCounts(base, f);
    var names = Object.keys(fc.c).sort();
    var cur = ui.panel[f.key];
    if (!names.length && cur === 'all') return '';
    var lbl = cur === 'all' ? f.title : (cur === 'none' ? 'Without a stone' : cur);
    var open = ui.panel.open === f.key;
    var h = '<span class="wv11-fdd"><button type="button" class="wv11-fchip' + (cur !== 'all' ? ' is-set' : '') + '" data-wv11-act="fdd-toggle" data-key="' + f.key + '" aria-expanded="' + open + '" aria-haspopup="listbox"><span class="wv11-fchip__t">' + esc(lbl) + '</span>' + ICON.chev + '</button>';
    if (open) {
      h += '<span class="wv11-stonelist" role="listbox" aria-label="' + esc(f.title) + '">';
      h += optionBtn(f.key, 'all', 'All', null, cur === 'all');
      h += names.map(function (n) { return optionBtn(f.key, n, n, fc.c[n], cur === n); }).join('');
      if (f.key === 'stone' && fc.none) h += optionBtn('stone', 'none', 'Without a stone', fc.none, cur === 'none', 'wv11-stonelist__none');
      h += '</span>';
    }
    return h + '</span>';
  }

  function sortDd() {
    var cur = SORTS.filter(function (x) { return x.v === ui.panel.sort; })[0] || SORTS[0];
    var open = ui.panel.open === 'sort';
    var h = '<span class="wv11-fdd wv11-sortdd"><button type="button" class="wv11-sortbtn" data-wv11-act="fdd-toggle" data-key="sort" aria-expanded="' + open + '" aria-haspopup="listbox"><span class="wv11-sortbtn__full">Sort: ' + esc(cur.l) + '</span><span class="wv11-sortbtn__short">Sort</span>' + ICON.chev + '</button>';
    if (open) h += '<span class="wv11-stonelist" role="listbox" aria-label="Sort">' + SORTS.map(function (x) { return optionBtn('sort', x.v, x.l, null, x.v === cur.v); }).join('') + '</span>';
    return h + '</span>';
  }

  function favCount() { return favs().filter(function (h) { return catalog.byHandle[h]; }).length; }
  function activeCount() { return (ui.panel.favOnly ? 1 : 0) + FACETS.filter(function (f) { return ui.panel[f.key] !== 'all'; }).length; }

  function filterBar(base) {
    var fav = '<button type="button" class="wv11-fchip' + (ui.panel.favOnly ? ' is-set' : '') + '" data-wv11-act="fav-only" aria-pressed="' + !!ui.panel.favOnly + '">' + (ui.panel.favOnly ? ICON.heartFull : ICON.heart) + 'Favourites ' + favCount() + '</button>';
    var n = activeCount();
    return '<div class="wv11-fbar"><div class="wv11-fbar__chips">' + fav + FACETS.map(function (f) { return facetDd(f, base); }).join('') + '</div>' +
      '<button type="button" class="wv11-fchip wv11-fbar__more" data-wv11-act="sheet-filters">Filters' + (n ? ' · ' + n : '') + ICON.chev + '</button>' +
      sortDd() + '</div>';
  }

  // Phones: the filters in one sheet
  function filterSheet(base, count) {
    var h = '<div class="wv11-fsheet" role="dialog" aria-label="Filters"><div class="wv11-fsheet__card"><div class="wv11-sheet__head"><h3>Filters</h3><button type="button" class="wv11-x" data-wv11-act="sheet-filters-close" aria-label="Close">' + ICON.close + '</button></div>';
    h += '<div class="wv11-fsheet__group"><button type="button" class="wv11-fchip' + (ui.panel.favOnly ? ' is-set' : '') + '" data-wv11-act="fav-only" aria-pressed="' + !!ui.panel.favOnly + '">' + (ui.panel.favOnly ? ICON.heartFull : ICON.heart) + 'Favourites ' + favCount() + '</button></div>';
    FACETS.forEach(function (f) {
      var fc = facetCounts(base, f), names = Object.keys(fc.c).sort(), cur = ui.panel[f.key];
      if (!names.length && cur === 'all') return;
      h += '<div class="wv11-fsheet__group"><span class="wv11-eb">' + esc(f.title) + '</span><div class="wv11-fsheet__opts">' + optionBtn(f.key, 'all', 'All', null, cur === 'all') +
        names.map(function (n) { return optionBtn(f.key, n, n, fc.c[n], cur === n); }).join('') +
        (f.key === 'stone' && fc.none ? optionBtn('stone', 'none', 'Without a stone', fc.none, cur === 'none') : '') + '</div></div>';
    });
    h += '<div class="wv11-fsheet__group"><span class="wv11-eb">Sort</span><div class="wv11-fsheet__opts">' + SORTS.map(function (x) { return optionBtn('sort', x.v, x.l, null, x.v === ui.panel.sort); }).join('') + '</div></div>';
    h += '<div class="wv11-fsheet__foot">' + (activeCount() ? '<button type="button" class="wv11-link" data-wv11-act="clear-filters">Clear all</button>' : '<span></span>') +
      '<button type="button" class="wv11-btn2" data-wv11-act="sheet-filters-close">Show ' + count + (count === 1 ? ' piece' : ' pieces') + '</button></div>';
    return h + '</div></div>';
  }

  // Her own piece for the selection: the first piece in her bag, in the other
  // metal when there is one (gold in the bag: the silver photo, and so on).
  // Only on the full list, sorted as chosen for her, with no search or filter.
  function ownPiece(s, f) {
    var P = ui.panel;
    if (P.sort !== 'chosen' || f.term || activeCount()) return null;
    var first = bagProfile(s).first, p = first && catalog.byHandle[first.h];
    if (!p || (P.group !== 'all' && P.group !== p.g)) return null;
    var line = q('.wv11-line[data-handle="' + p.h + '"]', drawer());
    var mine = line ? qa('.wv11-sumv', line).map(function (x) { return x.textContent.trim(); }) : [];
    var metals = Object.keys(p.v || {});
    var other = metals.filter(function (m) { return mine.indexOf(m) < 0; })[0];
    if (other && mine.some(function (m) { return metals.indexOf(m) >= 0; })) {
      return { p: p, imgs: [p.v[other]], name: shortTitle(p.t) + ' · ' + other };
    }
    return { p: p, imgs: p.imgs, name: shortTitle(p.t) };
  }

  function listHtml(s) {
    var f = filtered(s);
    var P = ui.panel;
    var groupBase = f.base.filter(function (p) { return passes(p, 'group'); });
    var tabs = '<div class="wv11-ctabs" role="tablist" aria-label="Type">' + ['all'].concat(catalog.groups).map(function (g) {
      var n = g === 'all' ? groupBase.length : groupBase.filter(function (p) { return p.g === g; }).length;
      return '<button type="button" role="tab" aria-selected="' + (P.group === g) + '" data-wv11-act="filter" data-key="group" data-value="' + esc(g) + '">' + (g === 'all' ? 'All' : esc(g)) + '<span>' + n + '</span></button>';
    }).join('') + '</div>';
    var search = '<div class="wv11-search">' + ICON.search + '<input type="search" data-wv11-search placeholder="Search by name, stone or style" aria-label="Search jewellery" value="' + esc(P.q) + '"></div>';

    var hasRecent = kept(RECENT_KEY).some(function (hd) { return catalog.byHandle[hd]; });
    var h = panelBar('Bag', 'panel-close', s) + '<div class="wv11-panel__scroll' + (hasRecent ? ' has-float' : '') + '" data-wv11-scroll>';
    h += '<div class="wv11-pin">' + search + tabs + filterBar(f.base) + '</div>';

    // Result count, applied filters as tags, Clear all
    var n = f.list.length;
    var countTxt = f.term ? n + (n === 1 ? ' piece' : ' pieces') + ' for “' + esc(P.q.trim()) + '”' : n + (n === 1 ? ' piece' : ' pieces') + ' chosen to go with yours';
    var tags = [];
    if (P.favOnly) tags.push(['fav', 'Favourites']);
    FACETS.forEach(function (x) { if (P[x.key] !== 'all') tags.push([x.key, P[x.key] === 'none' ? 'Without a stone' : P[x.key]]); });
    h += '<div class="wv11-active"><span class="wv11-active__count">' + countTxt + '</span>' +
      tags.map(function (t) { return '<span class="wv11-tag">' + esc(t[1]) + '<button type="button" data-wv11-act="tag-remove" data-key="' + t[0] + '" aria-label="Remove ' + esc(t[1]) + '"><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></span>'; }).join('') +
      (tags.length ? '<button type="button" class="wv11-link wv11-active__clear" data-wv11-act="clear-filters">Clear all</button>' : '') +
      (f.term && P.group !== 'all' && !P.allCats ? '<button type="button" class="wv11-link wv11-active__clear" data-wv11-act="search-all">Search all categories instead</button>' : '') + '</div>';

    if (n) {
      // Tags: "Signature" (your promoted pieces), "The perfect pair" (the
      // complementary picks of the pieces in her bag), then no tag
      var pairs = []; bagProfile(s).pieces.forEach(function (b) { pairs = pairs.concat(b.r || []); });
      var card = function (p, imgs, name, own) {
        return '<div class="wv11-card">' + slideHtml(imgs || p.imgs, { small: true, lazy: true, tag: own ? '' : p.pr ? 'Signature' : pairs.indexOf(p.h) >= 0 ? 'The perfect pair' : '', fav: p.h, title: p.t, act: 'detail', handle: p.h }) +
          '<button type="button" class="wv11-card__open" data-wv11-act="detail" data-handle="' + esc(p.h) + '"><span class="wv11-card__name">' + esc(name || shortTitle(p.t)) + '</span>' + priceHtml(p.p, s) + '</button></div>';
      };
      var cells = f.list.map(function (p) { return card(p); });
      var own = ownPiece(s, f);
      if (own) {
        // Right after your Signature pieces: the note, then her own piece in
        // the other metal. The note always takes a left-hand cell.
        var cols = window.innerWidth >= 960 ? 3 : 2;
        var at = 0; while (at < f.list.length && f.list[at].pr) at++;
        if (at % cols === cols - 1) at++;
        var note = window.WomuseNotes && window.WomuseNotes.pick('Bag');
        // The notes load after the page: if they were not in yet, draw the list again once they are
        if (window.WomuseNotes && !note && !ui.wvnWait) { ui.wvnWait = true; window.WomuseNotes.ready().then(function () { if (window.WomuseNotes.pick('Bag')) refreshList(); }); }
        cells.splice(Math.min(at, cells.length), 0, (note ? window.WomuseNotes.html(note, { cls: 'wv11-card' }) : '') + card(own.p, own.imgs, own.name, true));
      }
      h += '<div class="wv11-grid">' + cells.join('') + '</div>';
    } else {
      h += '<p class="wv11-empty">' + (P.favOnly && !favCount() ? 'Tap the heart on any piece to keep it in your favourites.' : 'Nothing matches that yet. Try another word, or clear a filter.') + '</p>';
    }

    h += '</div>';
    // Recently viewed: a slim strip floating at the bottom, with Back to top above it.
    // Both hide while she scrolls down and come back when she scrolls up.
    var rc = kept(RECENT_KEY).filter(function (hd) { return catalog.byHandle[hd]; });
    h += '<div class="wv11-float" data-wv11-float><button type="button" class="wv11-top" data-wv11-act="to-top" hidden>' + ICON.up + 'Back to top</button>';
    if (rc.length) {
      h += '<section class="wv11-recentbar" aria-label="Recently viewed"><span class="wv11-recentbar__lbl">Recently<br>viewed</span><div class="wv11-recentbar__strip">' + rc.slice(0, 12).map(function (hd) {
        var p = catalog.byHandle[hd];
        return '<button type="button" data-wv11-act="detail" data-handle="' + esc(hd) + '" aria-label="' + esc(p.t) + '"><img src="' + esc(p.i) + '" alt="" loading="lazy"></button>';
      }).join('') + '</div></section>';
    }
    h += '</div>';
    if (P.sheet) h += filterSheet(f.base, n);
    return h;
  }

  // Browse all, full screen while she scrolls: the Filters row folds away,
  // then the tabs fold up under the search, then the search slides up too.
  // 2 seconds still: the search comes back on its own. Tapping the search, or
  // going back to the top, brings everything back. Only her finger (or the
  // mouse wheel) starts the folding, so the list moving as the bar folds can
  // never set it off again.
  var pinT = [], pinIdleT = 0;
  function pinLevel(pin) { return pin.classList.contains('is-tucked3') ? 3 : pin.classList.contains('is-tucked2') ? 2 : pin.classList.contains('is-tucked') ? 1 : 0; }
  function pinStage(pin, n) {
    pinT.forEach(clearTimeout); pinT = [];
    if (n === 0) clearTimeout(pinIdleT);
    pin.classList.toggle('is-tucked', n >= 1);
    pin.classList.toggle('is-tucked2', n >= 2);
    pin.classList.toggle('is-tucked3', n >= 3);
  }
  function pinIdle(pin) {
    clearTimeout(pinIdleT);
    pinIdleT = setTimeout(function () { if (pinLevel(pin) === 3) pin.classList.remove('is-tucked3'); }, 2000);
  }
  function pinFold(sc) {
    var pin = q('.wv11-pin', sc); if (!pin || sc.scrollTop < 60 || pin.contains(document.activeElement)) return;
    var lv = pinLevel(pin);
    if (lv < 3 && !pinT.length) {
      [1, 2, 3].filter(function (n) { return n > lv; }).forEach(function (n, k) {
        pinT.push(setTimeout(function () { pin.classList.add(n === 1 ? 'is-tucked' : 'is-tucked' + n); if (n === 3) pinT = []; }, k * 140));
      });
    }
    pinIdle(pin);
  }
  var pinTouch = null;
  document.addEventListener('touchstart', function (e) {
    var sc = e.target.closest && e.target.closest('[data-wv11-scroll]');
    pinTouch = sc && e.touches.length === 1 ? { sc: sc, y: e.touches[0].clientY } : null;
  }, { passive: true });
  document.addEventListener('touchmove', function (e) {
    if (!pinTouch) return;
    if (Math.abs(e.touches[0].clientY - pinTouch.y) > 8) pinFold(pinTouch.sc);
  }, { passive: true });
  document.addEventListener('touchend', function () { pinTouch = null; });
  document.addEventListener('wheel', function (e) {
    var sc = e.target.closest && e.target.closest('[data-wv11-scroll]');
    if (sc && Math.abs(e.deltaY) > 4) pinFold(sc);
  }, { passive: true });
  // Tapping the search brings the tabs and Filters back
  document.addEventListener('focusin', function (e) {
    var pin = e.target.closest && e.target.matches('[data-wv11-search]') && e.target.closest('.wv11-pin');
    if (pin) pinStage(pin, 0);
  });

  function onPanelScroll(sc) {
    var y = sc.scrollTop;
    var fl = q('[data-wv11-float]', sc.parentNode);
    var last = ui.panel && ui.panel.lastY != null ? ui.panel.lastY : y;
    if (fl) {
      var topBtn = q('.wv11-top', fl);
      if (topBtn) topBtn.hidden = y < 500;
      if (y < 40 || y < last - 6) fl.classList.remove('is-hidden');
      else if (y > last + 6) fl.classList.add('is-hidden');
    }
    // Top of the list: everything back. While the list keeps moving, the bar
    // stays folded (see pinFold below); 2 seconds still brings the search back.
    var pin = q('.wv11-pin', sc);
    if (pin) {
      if (y < 60) pinStage(pin, 0);
      else if (pinLevel(pin) > 0) pinIdle(pin);
    }
    if (ui.panel && ui.panel.view === 'list') {
      ui.panel.listTop = y;
      if (Math.abs(y - last) > 6 || ui.panel.lastY == null) ui.panel.lastY = y;
    }
  }

  function matchVariant(p, sel) {
    if (!p) return null;
    return p.variants.filter(function (v) { return p.options.every(function (_, i) { return sel[i] != null ? v.options[i] === sel[i] : false; }); })[0] ||
      (p.variants.length === 1 ? p.variants[0] : null);
  }

  function detailHtml(s) {
    var p = products[ui.panel.handle];
    var c = catalog.byHandle[ui.panel.handle] || {};
    var back = ui.panel.from === 'list' ? ['All pieces', 'panel-list'] : ['Bag', 'panel-close'];
    if (!p) return panelBar(back[0], back[1], s) + '<div class="wv11-panel__scroll"><p class="wv11-loading">This piece is no longer available.</p></div>';
    var sel = ui.panel.sel || {};
    var imgs = (p.images || []).slice(0, 5).map(function (src) { return img600(src).replace(/(\.[a-z]+)(\?|$)/i, '$1$2') + (String(src).indexOf('?') >= 0 ? '&' : '?') + 'width=900'; });
    if (!imgs.length && c.imgs) imgs = c.imgs;
    var v0 = matchVariant(p, sel);
    var price = v0 ? v0.price : p.price;
    // The chosen metal's own photo leads the slider
    var ci0 = p.options.findIndex(isColour);
    var vm = v0 || (ci0 >= 0 && sel[ci0] != null ? p.variants.filter(function (v) { return v.options[ci0] === sel[ci0] && v.featured_image; })[0] : null);
    if (vm && vm.featured_image && vm.featured_image.src) {
      var vsrc = img600(vm.featured_image.src) + (String(vm.featured_image.src).indexOf('?') >= 0 ? '&' : '?') + 'width=900';
      var base = function (u) { return String(u).split('?')[0].replace(/^https?:/, ''); };
      imgs = [vsrc].concat(imgs.filter(function (u) { return base(u) !== base(vsrc); }));
    }
    var h = panelBar(back[0], back[1], s) + '<div class="wv11-panel__scroll" style="padding:0;gap:0">';
    h += galleryHtml(imgs, p.handle, p.title, 'wv11-gallery--detail');
    h += '<div class="wv11-detail"><div style="display:flex;flex-direction:column;gap:6px"><h3 class="wv11-detail__name">' + esc(p.title) + '</h3>' + priceHtml(price, s) + '</div>';
    var missing = null;
    var hasOptions = !(p.variants.length === 1 && p.variants[0].title === 'Default Title');
    if (hasOptions) {
      p.options.forEach(function (o, i) {
        var name = optName(o);
        var vals = uniq(p.variants.map(function (v) { return v.options[i]; }));
        var avail = function (val) { return p.variants.some(function (v) { return v.available && v.options[i] === val && p.options.every(function (_, j) { return j === i || sel[j] == null || v.options[j] === sel[j]; }); }); };
        if (isColour(o)) {
          if (sel[i] == null && !missing) missing = name;
          h += '<div style="display:flex;flex-direction:column;gap:10px"><span style="font-size:15px">' + esc(name) + ': <span style="color:var(--wv11-muted)">' + esc(sel[i] || 'choose') + '</span></span><div class="wv11-swatches">' +
            vals.map(function (val) { return '<button type="button" data-wv11-act="opt-pick" data-index="' + i + '" data-value="' + esc(val) + '" aria-pressed="' + (sel[i] === val) + '" aria-label="' + esc(val) + '"' + (avail(val) ? '' : ' disabled') + '><span style="background:' + swatch(val) + '"></span></button>'; }).join('') + '</div></div>';
        } else if (isSize(o)) {
          var standard = vals.filter(function (v) { return !isCustom(v); });
          var custom = vals.filter(isCustom)[0];
          var isCust = custom && sel[i] === custom;
          if ((sel[i] == null || (isCust && !ui.panel.custom.trim())) && !missing) missing = 'size';
          var known = s.ringSize && sel[i] === s.ringSize;
          h += '<div><button type="button" class="wv11-sizehead" data-wv11-act="size-toggle" aria-expanded="' + ui.panel.sizeOpen + '"><span>' + esc(name) + ': ' + esc(isCust ? 'Custom' : (sel[i] ? ringLabel(o, sel[i]) : 'choose')) + (known ? ' <small>· same as the ring in your bag</small>' : '') + '</span>' + (ui.panel.sizeOpen ? ICON.chevUp : ICON.chev) + '</button>';
          if (ui.panel.sizeOpen) {
            if (isRing(o) && RINGS) h += '<div class="wv11-ringsw-row">' + ringSwitch() + '</div>';
            h += '<div class="wv11-sizes">' + standard.map(function (val) { return '<button type="button" data-wv11-act="opt-pick" data-index="' + i + '" data-value="' + esc(val) + '" aria-pressed="' + (sel[i] === val) + '"' + (avail(val) ? '' : ' disabled') + '>' + ringBtn(o, val) + '</button>'; }).join('') + '</div>';
            if (custom) {
              h += '<button type="button" class="wv11-rowbtn" data-wv11-act="opt-pick" data-index="' + i + '" data-value="' + esc(custom) + '" aria-pressed="' + !!isCust + '"><span>Custom size<small>Made to your exact size</small></span>' + ICON.arrow + '</button>';
              if (isCust) h += '<div class="wv11-custom"><input type="text" inputmode="decimal" data-wv11-custom placeholder="' + esc(isRing(o) ? ringPlaceholder() : 'Your size, for example 7.25') + '" value="' + esc(ui.panel.custom) + '" aria-label="Your exact ring size"><small>We make it in your exact size.</small></div>';
            }
          }
          h += '</div>';
        } else {
          if (sel[i] == null && !missing) missing = name;
          h += '<div style="display:flex;flex-direction:column;gap:10px"><span style="font-size:15px">' + esc(name) + '</span><div class="wv11-sheet__chips">' +
            vals.map(function (val) { return '<button type="button" data-wv11-act="opt-pick" data-index="' + i + '" data-value="' + esc(val) + '" aria-pressed="' + (sel[i] === val) + '"' + (avail(val) ? '' : ' disabled') + '>' + esc(val) + '</button>'; }).join('') + '</div></div>';
        }
      });
    }
    var variant = matchVariant(p, sel);
    h += '</div></div><div class="wv11-panel__foot">';
    if (variant && variant.available && !missing) h += '<button type="button" class="wv11-addbtn" data-wv11-act="add-detail" data-variant="' + variant.id + '">Add to bag · ' + money(priv(variant.price, s), s.moneyFormat) + '</button>';
    else h += '<button type="button" class="wv11-addbtn" disabled>' + (missing ? 'Choose your ' + esc(String(missing).toLowerCase()) : 'Not available') + '</button>';
    return h + '</div>';
  }

  /* ---------------- 5.6b gift photo, larger ---------------- */

  // Opens over the bag; tap the photo to zoom, swipe or use the arrows for
  // more photos; close returns her to the gift choice exactly where she was.
  var lb = null;
  function lbSrc(u) { return img600(u).split('?')[0] + '?width=1400'; }
  function openLightbox(handle, variantId) {
    var d = drawer(); if (!d) return;
    loadProduct(handle).then(function (p) {
      var imgs = (p.images || []).map(lbSrc);
      var v = p.variants.filter(function (x) { return x.id === Number(variantId); })[0];
      if (v && v.featured_image && v.featured_image.src) {
        var vs = lbSrc(v.featured_image.src);
        imgs = [vs].concat(imgs.filter(function (u) { return u !== vs; }));
      }
      if (!imgs.length) return;
      lb = { imgs: imgs, i: 0, zoom: false, title: p.title };
      var el = q('[data-wv11-lightbox]', d);
      if (!el) { el = document.createElement('div'); el.className = 'wv11-lightbox'; el.setAttribute('data-wv11-lightbox', ''); el.setAttribute('role', 'dialog'); el.setAttribute('aria-modal', 'true'); el.setAttribute('data-scroll-lock-ignore', ''); q('.quick-cart__container', d).appendChild(el); }
      el.setAttribute('aria-label', p.title);
      el.classList.remove('is-full');
      el.innerHTML = '<div class="wv11-lightbox__dim" data-wv11-lb="close"></div><div class="wv11-lightbox__card"><span class="wv11-sheet__grab wv11-lightbox__grab" data-wv11-lb-grab></span>' +
        '<div class="wv11-lightbox__bar" data-wv11-lb-grab><span class="wv11-lightbox__name">' + esc(p.title) + '</span><button type="button" class="wv11-x" data-wv11-lb="close" aria-label="Close">' + ICON.close + '</button></div>' +
        '<div class="wv11-lightbox__stage" data-wv11-lb-stage><img src="' + esc(imgs[0]) + '" alt="' + esc(p.title) + '" data-wv11-lb-img draggable="false">' +
        (imgs.length > 1 ? '<button type="button" class="wv11-slide__prev" data-wv11-lb="prev" aria-label="Previous photo" hidden>' + ICON.prev + '</button><button type="button" class="wv11-slide__next" data-wv11-lb="next" aria-label="Next photo">' + ICON.next + '</button>' : '') + '</div>' +
        '<span class="wv11-lightbox__line" aria-hidden="true"><span style="width:' + (100 / imgs.length) + '%"></span></span>' +
        '<p class="wv11-lightbox__hint">Tap the photo to zoom</p></div>';
      el.hidden = false;
      // Same zoom as the product page viewer (tap, tap closer, tap out; pinch; drag)
      if (window.WomuseZoom) lb.z = window.WomuseZoom.attach(q('[data-wv11-lb-stage]', el), q('[data-wv11-lb-img]', el), {
        root: el,
        hi: function () { return lb ? lb.imgs[lb.i].replace('width=1400', 'width=2000') : ''; },
        swipe: function (d) { if (lb) lbShow(lb.i + d); }
      });
      var x = q('[data-wv11-lb="close"]', el); if (x) x.focus();
    });
  }
  function lbShow(i) {
    var el = q('[data-wv11-lightbox]', drawer()); if (!el || !lb) return;
    lb.i = Math.max(0, Math.min(lb.imgs.length - 1, i));
    if (lb.z) lb.z.reset(); else lbZoom(false);
    q('[data-wv11-lb-img]', el).src = lb.imgs[lb.i];
    var pv = q('[data-wv11-lb="prev"]', el), nx = q('[data-wv11-lb="next"]', el);
    if (pv) pv.hidden = lb.i === 0;
    if (nx) nx.hidden = lb.i === lb.imgs.length - 1;
    var ln = q('.wv11-lightbox__line span', el); if (ln) ln.style.left = (100 / lb.imgs.length * lb.i) + '%';
  }
  function lbZoom(on, ev) {
    var el = q('[data-wv11-lightbox]', drawer()); if (!el || !lb) return;
    var img = q('[data-wv11-lb-img]', el);
    lb.zoom = on;
    el.classList.toggle('is-zoomed', on);
    if (on && ev) lbPan(ev); else img.style.transformOrigin = '50% 50%';
  }
  function lbPan(ev) {
    var el = q('[data-wv11-lightbox]', drawer()); if (!el) return;
    var img = q('[data-wv11-lb-img]', el), r = img.getBoundingClientRect();
    var px = ((ev.clientX - r.left) / r.width) * 100, py = ((ev.clientY - r.top) / r.height) * 100;
    if (!lb.zoom) return;
    var st = img.style.transform; img.style.transform = 'none';
    r = img.getBoundingClientRect();
    px = Math.max(0, Math.min(100, ((ev.clientX - r.left) / r.width) * 100)); py = Math.max(0, Math.min(100, ((ev.clientY - r.top) / r.height) * 100));
    img.style.transform = st;
    img.style.transformOrigin = px + '% ' + py + '%';
  }
  function closeLightbox() {
    var el = q('[data-wv11-lightbox]', drawer()); if (!el) return;
    el.hidden = true; el.innerHTML = ''; lb = null;
  }
  document.addEventListener('click', function (e) {
    var d = drawer(); if (!d || !d.contains(e.target)) return;
    var z = e.target.closest('[data-wv11-zoom]');
    if (z) { e.preventDefault(); e.stopPropagation(); openLightbox(z.dataset.wv11Zoom, z.dataset.variant); return; }
    var b = e.target.closest('[data-wv11-lb]');
    if (b) {
      e.preventDefault(); e.stopPropagation();
      if (b.dataset.wv11Lb === 'close') closeLightbox();
      else if (lb) lbShow(lb.i + (b.dataset.wv11Lb === 'next' ? 1 : -1));
      return;
    }
    var img = e.target.closest('[data-wv11-lb-img]');
    if (img && lb && lb.z) return;
    if (img && lb) { e.preventDefault(); e.stopPropagation(); if (lb.swiped) { lb.swiped = false; return; } lbZoom(!lb.zoom, e); return; }
    if (e.target.closest('[data-wv11-lightbox]')) { e.stopPropagation(); }
  }, true);
  document.addEventListener('keydown', function (e) {
    if (!lb) return;
    if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); closeLightbox(); return; }
    if (e.key === 'ArrowRight') { lbShow(lb.i + 1); }
    if (e.key === 'ArrowLeft') { lbShow(lb.i - 1); }
    var z = e.target.closest && e.target.closest('[data-wv11-zoom]');
    if (z && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); openLightbox(z.dataset.wv11Zoom, z.dataset.variant); }
  }, true);
  document.addEventListener('keydown', function (e) {
    var z = !lb && e.target.closest && e.target.closest('span[data-wv11-zoom]');
    if (z && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); e.stopPropagation(); openLightbox(z.dataset.wv11Zoom, z.dataset.variant); }
  }, true);
  document.addEventListener('mousemove', function (e) {
    if (lb && !lb.z && lb.zoom && e.target.closest && e.target.closest('[data-wv11-lb-stage]')) lbPan(e);
  });
  // Phones: drag the handle or title up for full screen, down to close
  var lbDrag = null;
  document.addEventListener('touchstart', function (e) {
    if (!lb || !e.target.closest || e.target.closest('button') || !e.target.closest('[data-wv11-lb-grab]')) return;
    var card = e.target.closest('.wv11-lightbox__card');
    lbDrag = { card: card, y0: e.touches[0].clientY, dy: 0 };
    card.style.transition = 'none';
  }, { passive: true });
  document.addEventListener('touchmove', function (e) {
    if (!lbDrag) return;
    lbDrag.dy = e.touches[0].clientY - lbDrag.y0;
    if (lbDrag.dy > 0) lbDrag.card.style.transform = 'translateY(' + lbDrag.dy + 'px)';
  }, { passive: true });
  document.addEventListener('touchend', function () {
    if (!lbDrag) return;
    var g = lbDrag, box = g.card.parentNode; lbDrag = null;
    g.card.style.transition = 'transform 0.25s ease';
    if (g.dy < -50) { box.classList.add('is-full'); g.card.style.transform = ''; return; }
    if (g.dy > 90) {
      if (box.classList.contains('is-full')) { box.classList.remove('is-full'); g.card.style.transform = ''; return; }
      g.card.style.transform = 'translateY(100%)'; setTimeout(closeLightbox, 220); return;
    }
    g.card.style.transform = '';
  });
  var lbTouch = null;
  document.addEventListener('touchstart', function (e) {
    if (!lb || lb.z || !e.target.closest || !e.target.closest('[data-wv11-lb-stage]')) return;
    var t = e.touches[0]; lbTouch = { x: t.clientX, y: t.clientY };
  }, { passive: true });
  document.addEventListener('touchmove', function (e) {
    if (!lb || !lbTouch || !lb.zoom) return;
    lbPan(e.touches[0]);
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (!lb || !lbTouch) return;
    var t = e.changedTouches[0], dx = t.clientX - lbTouch.x, dy = t.clientY - lbTouch.y;
    lbTouch = null;
    if (!lb.zoom && Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { lb.swiped = true; lbShow(lb.i + (dx < 0 ? 1 : -1)); setTimeout(function () { if (lb) lb.swiped = false; }, 400); }
  });

  /* ---------------- 5.7 cart actions ---------------- */

  function secondPieceProps(s) {
    return (s && s.live && !s.hasSelection && s.paidUnits >= 1) ? { _womuse_selection: '1' } : {};
  }

  function addSecondPiece(variantId, extra) {
    var s = readState();
    var props = Object.assign({}, secondPieceProps(s), extra || {});
    return post('cart/add.js', { items: [{ id: Number(variantId), quantity: 1, properties: props }] }).then(function () {
      ui.panel = null; ui.sel = 'closed'; ui.selMetal = null; renderPanel(); return refresh();
    });
  }

  // While a button works: the W from the logo turns into a point, opens into a
  // circle and comes back (gold sparkles around it when the Christmas switch is on)
  function loader() {
    var d = drawer(), xmas = d && d.getAttribute('data-wv11-xmas') === 'true';
    return '<span class="wv-load' + (xmas ? ' wv-load--xmas' : '') + '" role="status" aria-label="Loading"><svg viewBox="0 0 40 40" aria-hidden="true"><circle class="wv-load__c" cx="20" cy="20" r="15"/><text class="wv-load__w" x="20" y="31" text-anchor="middle">W</text></svg>' +
      (xmas ? '<i></i><i></i><i></i><i></i>' : '') + '</span>';
  }
  // Secure checkout: the W shows in the button while checkout opens; the
  // words come back if she returns to the page (or after 10 seconds)
  function checkoutBack() { qa('.wv11-checkout[data-wv-go]').forEach(function (b) { if (b.dataset.label) b.innerHTML = b.dataset.label; b.removeAttribute('data-wv-go'); }); }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.wv11-checkout');
    if (!b || b.hasAttribute('data-wv-go')) return;
    b.setAttribute('data-wv-go', ''); b.dataset.label = b.innerHTML;
    setTimeout(function () { b.innerHTML = loader(); }, 0);
    setTimeout(checkoutBack, 10000);
  });
  window.addEventListener('pageshow', checkoutBack);
  function busy(btn, on, text) { if (!btn) return; btn.disabled = on; if (text) { if (on) { btn.dataset.label = btn.innerHTML; btn.innerHTML = loader(); } else if (btn.dataset.label) { btn.innerHTML = btn.dataset.label; } } }

  function changeQty(line, delta) {
    var s = readState();
    var key = line.dataset.key, qty = Number(line.dataset.quantity) + delta;
    line.setAttribute('aria-busy', 'true');
    // The same piece again while the offer is live: it becomes her second
    // piece on its own line, so the first keeps its own discount.
    if (delta > 0 && s && s.live && !s.hasSelection && s.paidUnits >= 1 && line.dataset.eligible === 'true') {
      var props = {};
      props = lineProps(line);
      props._womuse_selection = '1';
      return post('cart/add.js', { items: [{ id: Number(line.dataset.variantId), quantity: 1, properties: props }] })
        .then(refresh).catch(function (e) { console.error('[WOMUSE bag]', e); line.removeAttribute('aria-busy'); });
    }
    // + on her second piece (the one at the offer price): the extra one is a
    // normal piece on its own line, because the offer covers one piece only.
    // Without this the line would read "2 x" at a price only one of them has.
    if (delta > 0) {
      var own = lineProps(line);
      if (own._womuse_selection === '1') {
        delete own._womuse_selection; delete own._womuse_gift;
        return post('cart/add.js', { items: [{ id: Number(line.dataset.variantId), quantity: 1, properties: own }] })
          .then(refresh).catch(function (e) { console.error('[WOMUSE bag]', e); line.removeAttribute('aria-busy'); });
      }
    }
    var chain = Promise.resolve();
    if (qty <= 0) {
      chain = getCart().then(function (cart) {
        var item = cart.items.filter(function (i) { return i.key === key; })[0];
        var pos = qa('.wv11-lines > *', drawer()).indexOf(line.closest('[data-wv11-swipe]') || line);
        if (item && !item.properties._womuse_gift) store(UNDO_KEY, { ts: Date.now(), title: item.product_title, id: item.variant_id, quantity: item.quantity, properties: item.properties || {}, pos: pos });
      });
    }
    return chain.then(function () { return post('cart/change.js', { id: key, quantity: Math.max(0, qty) }); })
      .then(refresh)
      .catch(function (e) { console.error('[WOMUSE bag]', e); line.removeAttribute('aria-busy'); });
  }

  // Metal, size or any option changed right in the bag
  // A piece's notes, always as name -> value. The theme hands them over as a
  // list of [name, value] pairs; an older broken save looked like "0": [name, value].
  function lineProps(line) {
    var raw = null; try { raw = JSON.parse(line.dataset.properties || '{}'); } catch (e) { raw = null; }
    var out = {};
    var put = function (k, v) {
      if (Array.isArray(v) && v.length === 2 && /^\d+$/.test(String(k))) { put(v[0], v[1]); return; }
      if (k == null || k === '' || v == null || typeof v === 'object') return;
      out[String(k)] = String(v);
    };
    if (Array.isArray(raw)) raw.forEach(function (pair) { if (Array.isArray(pair)) put(pair[0], pair[1]); });
    else if (raw && typeof raw === 'object') Object.keys(raw).forEach(function (k) { put(k, raw[k]); });
    return out;
  }
  var sheetCtx = null;
  var DESKTOP = window.matchMedia ? window.matchMedia('(min-width: 960px)') : { matches: false };
  function closeOptDd() {
    qa('[data-wv11-optdd]').forEach(function (x) { x.remove(); });
    qa('[data-wv11-opt][aria-expanded="true"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    qa('.wv11-line.has-dd').forEach(function (l) { l.classList.remove('has-dd'); });
  }
  function openOptionDropdown(line, idx, btn) {
    var wasOpen = btn.getAttribute('aria-expanded') === 'true';
    closeOptDd();
    if (wasOpen) return;
    loadProduct(line.dataset.handle).then(function (p) {
      var o = p.options[idx]; var name = optName(o);
      var cur = p.variants.filter(function (v) { return v.id === Number(line.dataset.variantId); })[0];
      if (!cur) return;
      var vals = uniq(p.variants.map(function (v) { return v.options[idx]; }));
      var props = lineProps(line);
      var customVal = Object.keys(props).filter(function (k) { return /custom|requested/i.test(k) && /size/i.test(k); }).map(function (k) { return props[k]; })[0] || '';
      sheetCtx = { line: line, p: p, idx: idx, cur: cur, props: props, custom: customVal, customOn: isSize(o) && isCustom(cur.options[idx]) };
      var target = function (val) { return p.variants.filter(function (v) { return v.options[idx] === val && p.options.every(function (_, j) { return j === idx || v.options[j] === cur.options[j]; }); })[0]; };
      var standard = vals.filter(function (v) { return !(isSize(o) && isCustom(v)); });
      var custom = isSize(o) ? vals.filter(isCustom)[0] : null;
      var h = '<div class="wv11-dd__list wv11-optdd' + (isSize(o) ? ' wv11-optdd--size' : '') + '" data-wv11-optdd data-wv11-dd role="listbox" aria-label="Choose your ' + esc(name.toLowerCase()) + '">';
      h += standard.map(function (val) {
        var t = target(val);
        return '<button type="button" role="option" data-wv11-act="variant-pick" data-variant="' + (t ? t.id : '') + '" aria-selected="' + (val === cur.options[idx] && !sheetCtx.customOn) + '"' + (t && t.available ? '' : ' disabled') + '>' + esc(isSize(o) ? 'Size ' + ringLabel(o, val) : val) + '</button>';
      }).join('');
      if (custom) {
        var ct = target(custom);
        h += '<button type="button" role="option" class="wv11-optdd__custom-btn" data-wv11-act="sheet-custom" aria-selected="' + sheetCtx.customOn + '"' + (ct ? ' data-variant="' + ct.id + '"' : ' disabled') + '>Custom size</button>';
        h += '<div class="wv11-optdd__custom" data-wv11-sheet-custom' + (sheetCtx.customOn ? '' : ' hidden') + '><input type="text" inputmode="decimal" data-wv11-sheet-custom-input placeholder="' + esc(isRing(o) ? ringPlaceholder().replace(/^Your (UK |EU )?size, for/, 'For') : 'For example 7.25') + '" value="' + esc(customVal) + '" aria-label="Your exact ring size"><button type="button" class="wv11-optdd__save" data-wv11-act="sheet-custom-save" data-variant="' + (ct ? ct.id : '') + '">Save</button></div>';
      }
      h += '</div>';
      var box = btn.parentNode;
      box.classList.add('wv11-line__opts--dd');
      btn.insertAdjacentHTML('afterend', h);
      var list = q('[data-wv11-optdd]', box);
      list.style.left = btn.offsetLeft + 'px';
      list.style.top = (btn.offsetTop + btn.offsetHeight + 4) + 'px';
      list.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      line.classList.add('has-dd');
      var on = q('[aria-selected="true"]', list); if (on && list.scrollHeight > list.clientHeight) list.scrollTop = on.offsetTop - 60;
    });
  }
  function openOptionSheet(line, idx, btn) {
    if (DESKTOP.matches && btn) { openOptionDropdown(line, idx, btn); return; }
    var sheet = q('[data-wv11-sheet]', drawer()); if (!sheet) return;
    loadProduct(line.dataset.handle).then(function (p) {
      var o = p.options[idx]; var name = optName(o);
      var cur = p.variants.filter(function (v) { return v.id === Number(line.dataset.variantId); })[0];
      if (!cur) return;
      var vals = uniq(p.variants.map(function (v) { return v.options[idx]; }));
      var props = lineProps(line);
      var customVal = Object.keys(props).filter(function (k) { return /custom|requested/i.test(k) && /size/i.test(k); }).map(function (k) { return props[k]; })[0] || '';
      sheetCtx = { line: line, p: p, idx: idx, cur: cur, props: props, custom: customVal, customOn: isSize(o) && isCustom(cur.options[idx]) };
      var target = function (val) { return p.variants.filter(function (v) { return v.options[idx] === val && p.options.every(function (_, j) { return j === idx || v.options[j] === cur.options[j]; }); })[0]; };
      var standard = vals.filter(function (v) { return !(isSize(o) && isCustom(v)); });
      var custom = isSize(o) ? vals.filter(isCustom)[0] : null;
      var h = '<div style="flex:1" data-wv11-act="sheet-close"></div><div class="wv11-sheet__card" role="dialog" aria-label="Choose your ' + esc(name.toLowerCase()) + '"><span class="wv11-sheet__grab"></span>' +
        '<div class="wv11-sheet__head"><h3>Choose your ' + esc(name.toLowerCase()) + '</h3><button type="button" class="wv11-x" data-wv11-act="sheet-close" aria-label="Close">' + ICON.close + '</button></div>' +
        '<div class="wv11-sheet__chips">' + standard.map(function (val) {
          var t = target(val);
          return '<button type="button" data-wv11-act="variant-pick" data-variant="' + (t ? t.id : '') + '" aria-pressed="' + (val === cur.options[idx] && !sheetCtx.customOn) + '"' + (t && t.available ? '' : ' disabled') + '>' + ringBtn(o, val) + '</button>';
        }).join('') + '</div>';
      if (custom) {
        var ct = target(custom);
        h += '<button type="button" class="wv11-rowbtn" data-wv11-act="sheet-custom" aria-pressed="' + sheetCtx.customOn + '"' + (ct ? ' data-variant="' + ct.id + '"' : ' disabled') + '><span>Custom size<small>Made to your exact size</small></span>' + ICON.arrow + '</button>';
        h += '<div class="wv11-custom" data-wv11-sheet-custom' + (sheetCtx.customOn ? '' : ' hidden') + '><input type="text" inputmode="decimal" data-wv11-sheet-custom-input placeholder="' + esc(isRing(o) ? ringPlaceholder() : 'Your size, for example 7.25') + '" value="' + esc(customVal) + '" aria-label="Your exact ring size"><button type="button" class="wv11-addbtn" style="height:48px;border:0;border-radius:24px;background:#141414;color:#fff;font-size:14px;letter-spacing:1.2px" data-wv11-act="sheet-custom-save" data-variant="' + (ct ? ct.id : '') + '">SAVE MY SIZE</button></div>';
      }
      sheet.innerHTML = h + '</div>';
      sheet.hidden = false;
    });
  }
  function closeSheet() { var sh = q('[data-wv11-sheet]', drawer()); if (sh) { sh.hidden = true; sh.innerHTML = ''; } sheetCtx = null; editCtx = null; }

  // Phones: "Edit" on a piece opens one sheet with every choice (colour,
  // size, custom size) and a single Update button
  var editCtx = null;
  function openEditSheet(line) {
    var sheet = q('[data-wv11-sheet]', drawer()); if (!sheet) return;
    loadProduct(line.dataset.handle).then(function (p) {
      var cur = p.variants.filter(function (v) { return v.id === Number(line.dataset.variantId); })[0];
      if (!cur) return;
      var props = lineProps(line);
      var customVal = Object.keys(props).filter(function (k) { return /custom|requested/i.test(k) && /size/i.test(k); }).map(function (k) { return props[k]; })[0] || '';
      var sizeIdx = -1; p.options.forEach(function (o, i) { if (sizeIdx < 0 && isSize(o)) sizeIdx = i; });
      var img = q('.wv11-line__media img', line), price = q('.wv11-line__price', line);
      editCtx = { line: line, p: p, cur: cur, sel: cur.options.slice(), img: img ? (img.currentSrc || img.src) : '', price: price ? price.textContent : '' };
      sheetCtx = { line: line, p: p, idx: sizeIdx < 0 ? 0 : sizeIdx, cur: cur, props: props, custom: customVal, customOn: sizeIdx >= 0 && isCustom(cur.options[sizeIdx]) };
      sheet.innerHTML = editHtml();
      sheet.hidden = false;
    });
  }
  function editVariant(sel) {
    return editCtx.p.variants.filter(function (v) { return v.options.every(function (x, i) { return x === sel[i]; }); })[0];
  }
  function editHtml() {
    var e = editCtx, p = e.p, title = p.title;
    var h = '<div style="flex:1" data-wv11-act="sheet-close"></div><div class="wv11-sheet__card wv11-edit" role="dialog" aria-label="Edit your piece"><span class="wv11-sheet__grab"></span>' +
      '<div class="wv11-sheet__head"><h3>Edit your piece</h3><button type="button" class="wv11-x" data-wv11-act="sheet-close" aria-label="Close">' + ICON.close + '</button></div>' +
      '<div class="wv11-edit__piece">' + (e.img ? '<img src="' + esc(e.img) + '" alt="">' : '') + '<div><div class="wv11-edit__title">' + esc(title) + '</div><div class="wv11-edit__price">' + esc(e.price) + '</div></div></div>';
    p.options.forEach(function (o, i) {
      var vals = uniq(p.variants.map(function (v) { return v.options[i]; }));
      if (vals.length < 2) return;
      var name = optName(o);
      var ok = function (val) { var s2 = e.sel.slice(); s2[i] = val; var v = editVariant(s2); return v && v.available; };
      if (isColour(o)) {
        h += '<div class="wv11-edit__lbl">' + esc(name) + ': <span>' + esc(e.sel[i]) + '</span></div><div class="wv11-edit__sw">' + vals.map(function (val) {
          return '<button type="button" data-wv11-act="edit-pick" data-i="' + i + '" data-v="' + esc(val) + '" aria-pressed="' + (val === e.sel[i]) + '" aria-label="' + esc(val) + '"' + (ok(val) ? '' : ' disabled') + '><span style="background:' + swatch(val) + '"></span></button>';
        }).join('') + '</div>';
        return;
      }
      var standard = vals.filter(function (v) { return !(isSize(o) && isCustom(v)); });
      var custom = isSize(o) ? vals.filter(isCustom)[0] : null;
      h += '<div class="wv11-edit__lbl' + (isRing(o) && RINGS ? ' wv11-edit__lbl--ring' : '') + '">' + esc(name) + (isRing(o) && RINGS ? ringSwitch() : '') + '</div><div class="wv11-sheet__chips wv11-edit__chips">' + standard.map(function (val) {
        return '<button type="button" data-wv11-act="edit-pick" data-i="' + i + '" data-v="' + esc(val) + '" aria-pressed="' + (val === e.sel[i]) + '"' + (ok(val) ? '' : ' disabled') + '>' + (isSize(o) ? ringBtn(o, val) : esc(val)) + '</button>';
      }).join('') + '</div>';
      if (custom) {
        var s3 = e.sel.slice(); s3[i] = custom; var ct = editVariant(s3);
        var on = isCustom(e.sel[i]);
        h += '<button type="button" class="wv11-rowbtn" data-wv11-act="edit-pick" data-i="' + i + '" data-v="' + esc(custom) + '" aria-pressed="' + on + '"' + (ct ? '' : ' disabled') + '><span>Custom size<small>Made to your exact size</small></span>' + ICON.arrow + '</button>';
        h += '<div class="wv11-custom" data-wv11-sheet-custom' + (on ? '' : ' hidden') + '><input type="text" inputmode="decimal" data-wv11-sheet-custom-input placeholder="' + esc(isRing(o) ? ringPlaceholder() : 'Your size, for example 7.25') + '" value="' + esc(sheetCtx.custom) + '" aria-label="Your exact ring size"></div>';
      }
    });
    h += '<button type="button" class="wv11-edit__save" data-wv11-act="edit-save">UPDATE MY PIECE</button></div>';
    return h;
  }

  function swapVariant(variantId, customSize) {
    var ctx = sheetCtx; if (!ctx || !variantId) return Promise.resolve();
    var line = ctx.line, key = line.dataset.key, qty = Number(line.dataset.quantity) || 1;
    var props = Object.assign({}, ctx.props);
    Object.keys(props).forEach(function (k) { if (/custom|requested/i.test(k) && /size/i.test(k)) delete props[k]; });
    if (customSize) props['Custom ' + optName(ctx.p.options[ctx.idx]).toLowerCase()] = customNote(ctx.p.options[ctx.idx], customSize);
    line.setAttribute('aria-busy', 'true');
    closeSheet(); closeOptDd();
    return post('cart/change.js', { id: key, quantity: 0 })
      .then(function () { return post('cart/add.js', { items: [{ id: Number(variantId), quantity: qty, properties: props }] }); })
      .then(refresh)
      .catch(function (e) { console.error('[WOMUSE bag] swap', e); refresh(); });
  }

  function applyCodes(codes) {
    return post('cart/update.js', { discount: codes.join(',') });
  }

  function closeLists() {
    var d = drawer(); if (!d) return;
    qa('.wv11-dd__list', d).forEach(function (l) { l.hidden = true; });
    qa('[data-wv11-dd-toggle]', d).forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    closeOptDd();
  }

  function closeDrawer() {
    var d = drawer(); if (!d) return;
    var b = q('[data-modal-close]', d); if (b) b.click();
  }

  /* ---------------- 5.8 events ---------------- */

  document.addEventListener('click', function (e) {
    var d = drawer(); if (!d || !d.contains(e.target)) return;

    var fav = e.target.closest('[data-wv11-fav]');
    if (fav) { e.preventDefault(); e.stopPropagation(); toggleFav(fav.dataset.wv11Fav); if (ui.panel && ui.panel.view === 'list') { ui.panel.keepTop = true; renderPanel(); } return; }

    if (e.target.closest('[data-wv11-handle]')) { e.preventDefault(); closeDrawer(); return; }

    // Dropdowns (metal, gift metal) open under their button
    var ddT = e.target.closest('[data-wv11-dd-toggle]');
    if (ddT) {
      e.preventDefault();
      var list = q('.wv11-dd__list', ddT.parentNode), willOpen = list.hidden;
      closeLists(); list.hidden = !willOpen; ddT.setAttribute('aria-expanded', String(willOpen));
      return;
    }
    if (!e.target.closest('[data-wv11-dd], [data-wv11-opt]')) closeLists();

    var line = e.target.closest('[data-wv11-line]');
    var swipeDel = e.target.closest('[data-wv11-swipe-delete]');
    if (swipeDel) { e.preventDefault(); var l2 = q('[data-wv11-line]', swipeDel.parentNode); if (l2) changeQty(l2, -Number(l2.dataset.quantity)); return; }
    var openSwipe = e.target.closest('.wv11-swipe.is-open');
    if (openSwipe && line) { e.preventDefault(); openSwipe.classList.remove('is-open'); return; }
    var qtyBtn = e.target.closest('[data-wv11-qty]');
    if (qtyBtn && line) { e.preventDefault(); changeQty(line, Number(qtyBtn.dataset.wv11Qty)); return; }
    if (e.target.closest('[data-wv11-remove]') && line) { e.preventDefault(); changeQty(line, -Number(line.dataset.quantity)); return; }
    if (e.target.closest('[data-wv11-edit]') && line) { e.preventDefault(); openEditSheet(line); return; }
    var optBtn = e.target.closest('[data-wv11-opt]');
    if (optBtn && line) { e.preventDefault(); openOptionSheet(line, Number(optBtn.dataset.wv11Opt), optBtn); return; }
    if (!e.target.closest('[data-wv11-optdd]')) closeOptDd();

    if (e.target.closest('[data-wv11-total-toggle]')) { e.preventDefault(); ui.details = !ui.details; restoreFooter(); return; }
    if (e.target.closest('[data-wv11-code-toggle]')) { e.preventDefault(); ui.codeOpen = !ui.codeOpen; if (!ui.codeOpen) clearCodeNote(); restoreFooter(); if (ui.codeOpen) { var ci = q('[data-wv11-code-input]', d); if (ci) ci.focus(); } return; }

    // Warranty: tap on phones, hover on desktop (CSS)
    var wt = e.target.closest('[data-wv11-warranty-trigger]');
    if (wt) { e.preventDefault(); var w = wt.closest('[data-wv11-warranty]'); var open = w.classList.toggle('is-open'); wt.setAttribute('aria-expanded', String(open)); return; }
    if (e.target.closest('[data-wv11-warranty-open]')) {
      e.preventDefault(); var modal = q('[data-wv11-warranty-modal]', d); if (modal && modal.showModal) modal.showModal();
      qa('[data-wv11-warranty]', d).forEach(function (x) { x.classList.remove('is-open'); });
      return;
    }
    if (e.target.closest('[data-wv11-warranty-close]')) { e.preventDefault(); e.target.closest('dialog').close(); return; }
    if (e.target.matches && e.target.matches('dialog[data-wv11-warranty-modal]')) { e.target.close(); return; }
    qa('[data-wv11-warranty].is-open', d).forEach(function (x) { if (!x.contains(e.target)) x.classList.remove('is-open'); });

    var apply = e.target.closest('[data-wv11-code-apply]');
    if (apply) {
      e.preventDefault();
      var input = q('[data-wv11-code-input]', d), fb = q('[data-wv11-code-feedback]', d), code = input && input.value.trim();
      if (!code) { if (input) input.focus(); return; }
      busy(apply, true, '…');
      getCart().then(function (cart) {
        var codes = (cart.discount_codes || []).map(function (x) { return x.code; }).filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); });
        codes.push(code);
        return applyCodes(codes);
      }).then(function (cart) {
        var ok = (cart.discount_codes || []).some(function (x) { return x.code.toLowerCase() === code.toLowerCase() && x.applicable; });
        if (!ok) {
          var keepCodes = (cart.discount_codes || []).filter(function (x) { return x.code.toLowerCase() !== code.toLowerCase(); }).map(function (x) { return x.code; });
          return applyCodes(keepCodes).then(function () { codeNote(fb, code.toUpperCase() + ' can’t be used with this bag.'); busy(apply, false, 'x'); });
        }
        ui.codeOpen = false;
        return refresh();
      }).catch(function () { codeNote(fb, 'We couldn’t apply that code. Please try again.'); busy(apply, false, 'x'); });
      return;
    }
    var rm = e.target.closest('[data-wv11-code-remove]');
    if (rm) {
      e.preventDefault();
      var drop = rm.dataset.wv11CodeRemove.toLowerCase();
      getCart().then(function (cart) {
        return applyCodes((cart.discount_codes || []).map(function (x) { return x.code; }).filter(function (c) { return c.toLowerCase() !== drop; }));
      }).then(refresh);
      return;
    }

    var act = e.target.closest('[data-wv11-act]');
    if (ui.panel && ui.panel.open && !e.target.closest('.wv11-fdd')) {
      ui.panel.open = null; ui.panel.keepTop = true;
      if (!act) { renderPanel(); return; }
    }
    if (!act) return;
    var a = act.dataset.wv11Act, s = panelState();
    e.preventDefault();

    if (a === 'slide-next' || a === 'slide-prev') {
      var sl = act.closest('[data-wv11-slide]'); var imgs = []; try { imgs = JSON.parse(sl.dataset.imgs); } catch (er) {}
      if (imgs.length < 2) return;
      var i = Math.max(0, Math.min(imgs.length - 1, Number(sl.dataset.i) + (a === 'slide-next' ? 1 : -1))); sl.dataset.i = i;
      q('img', sl).src = imgs[i];
      var bar = q('.wv11-slide__bar span', sl); if (bar) bar.style.transform = 'translateX(' + (i * 100) + '%)';
      var spv = q('.wv11-slide__prev', sl), snx = q('.wv11-slide__next', sl);
      if (spv) spv.hidden = i === 0;
      if (snx) snx.hidden = i === imgs.length - 1;
      return;
    }
    if (a === 'gal-next' || a === 'gal-prev') {
      var gt = q('[data-wv11-gallery]', act.closest('[data-wv11-gallery-wrap]')); if (!gt) return;
      var step = gt.firstElementChild ? gt.firstElementChild.getBoundingClientRect().width + 8 : gt.clientWidth;
      gt.scrollTo({ left: Math.max(0, gt.scrollLeft + (a === 'gal-next' ? step : -step)), behavior: REDUCED ? 'auto' : 'smooth' });
      return;
    }
    if (a === 'sel-open') {
      loadCatalog(s);
      ui.revealSel = true;
      if (REDUCED) { ui.sel = 'open'; renderRewards(); return; }
      act.classList.add('is-unlocking');
      wait(420).then(function () { ui.sel = 'open'; renderRewards(); });
      return;
    }
    if (a === 'sel-close') { ui.sel = 'closed'; renderRewards(); return; }
    if (a === 'sel-metal') { ui.selMetal = act.dataset.value; renderRewards(); return; }
    if (a === 'sel-add') { busy(act, true, 'Adding…'); addSecondPiece(act.dataset.variant).catch(function (err) { busy(act, false, 'x'); alertInline(act, err); }); return; }
    if (a === 'browse') { openPanel('list', null, { group: act.dataset.group || 'all', fav: act.dataset.tab === 'fav', focusSearch: act.dataset.focus === 'search' }); return; }
    if (a === 'detail') { openPanel('detail', act.dataset.handle); return; }
    if (a === 'panel-close') { closePanel(); return; }
    if (a === 'panel-list') { ui.panel.view = 'list'; ui.panel.sel = {}; ui.panel.custom = ''; renderPanel(); return; }
    if (a === 'filter') {
      ui.panel[act.dataset.key] = act.dataset.value; ui.panel.open = null; ui.panel.keepTop = true;
      if (act.dataset.key === 'group') { ui.panel.allCats = false; tidyFilters(s); }
      renderPanel(); return;
    }
    if (a === 'fdd-toggle') { ui.panel.open = ui.panel.open === act.dataset.key ? null : act.dataset.key; ui.panel.keepTop = true; renderPanel(); return; }
    if (a === 'fav-only') { ui.panel.favOnly = !ui.panel.favOnly; ui.panel.open = null; ui.panel.keepTop = true; renderPanel(); return; }
    if (a === 'tag-remove') { if (act.dataset.key === 'fav') ui.panel.favOnly = false; else ui.panel[act.dataset.key] = 'all'; ui.panel.keepTop = true; renderPanel(); return; }
    if (a === 'clear-filters') { ui.panel.favOnly = false; FACETS.forEach(function (x) { ui.panel[x.key] = 'all'; }); ui.panel.keepTop = true; renderPanel(); return; }
    if (a === 'search-all') { ui.panel.allCats = true; ui.panel.keepTop = true; renderPanel(); return; }
    if (a === 'sheet-filters') { ui.panel.sheet = true; ui.panel.open = null; ui.panel.keepTop = true; renderPanel(); return; }
    if (a === 'sheet-filters-close') { ui.panel.sheet = false; ui.panel.keepTop = true; renderPanel(); return; }
    if (a === 'to-top' || a === 'to-search') {
      var sc = q('[data-wv11-scroll]', d); if (sc) sc.scrollTo({ top: 0, behavior: REDUCED ? 'auto' : 'smooth' });
      if (a === 'to-search') { var si = q('[data-wv11-search]', d); if (si) setTimeout(function () { si.focus(); }, 300); }
      return;
    }
    if (a === 'size-toggle') { ui.panel.sizeOpen = !ui.panel.sizeOpen; renderPanel(); return; }
    if (a === 'ring-sys') {
      if (act.getAttribute('aria-pressed') === 'true') return;
      setRingSys(act.dataset.sys);
      var shR = q('[data-wv11-sheet]', d);
      if (editCtx && shR && !shR.hidden && q('[data-wv11-act="edit-save"]', shR)) {
        var keepR = q('[data-wv11-sheet-custom-input]', shR); if (keepR) sheetCtx.custom = keepR.value;
        shR.innerHTML = editHtml();
      } else if (ui.panel) renderPanel();
      paintRingPills();
      return;
    }
    if (a === 'opt-pick') {
      ui.panel.sel[act.dataset.index] = act.dataset.value;
      var p = products[ui.panel.handle];
      if (p) p.options.forEach(function (_, j) { if (j !== Number(act.dataset.index) && ui.panel.sel[j] != null && !p.variants.some(function (v) { return v.available && p.options.every(function (__, k) { return ui.panel.sel[k] == null || v.options[k] === ui.panel.sel[k]; }); })) delete ui.panel.sel[j]; });
      renderPanel();
      if (isCustom(act.dataset.value)) { var cu = q('[data-wv11-custom]', d); if (cu) cu.focus(); }
      return;
    }
    if (a === 'add-detail') {
      var extra = {};
      var pp = products[ui.panel.handle];
      if (pp) pp.options.forEach(function (o, k) { if (isSize(o) && isCustom(ui.panel.sel[k]) && ui.panel.custom.trim()) extra['Custom ' + optName(o).toLowerCase()] = customNote(o, ui.panel.custom.trim()); });
      busy(act, true, 'Adding…');
      addSecondPiece(act.dataset.variant, extra).catch(function (err) { busy(act, false, 'x'); alertInline(act, err); });
      return;
    }
    if (a === 'gift-alts') { ui.altOpen = true; renderRewards(); return; }
    if (a === 'gift-back') { ui.altOpen = false; ui.giftPick = null; ui.giftVariant = null; renderRewards(); return; }
    if (a === 'gift-pick') { ui.giftPick = act.dataset.handle; ui.giftVariant = null; renderRewards(); return; }
    if (a === 'gift-variant') { ui.giftVariant = Number(act.dataset.variant); renderRewards(); return; }
    if (a === 'gift-accept') {
      if (!s || !s.giftReady || s.giftKey || !act.dataset.variant) return;
      busy(act, true, 'Adding your gift…');
      store(ASIDE_KEY, null);
      post('cart/add.js', { items: [{ id: Number(act.dataset.variant), quantity: 1, properties: { _womuse_gift: '1' } }] })
        .then(function () { ui.altOpen = false; return refresh(); })
        .catch(function (err) { busy(act, false, 'x'); alertInline(act, err); });
      return;
    }
    if (a === 'undo') {
      var u = load(UNDO_KEY); if (!u) return;
      store(UNDO_KEY, null);
      post('cart/add.js', { items: [{ id: u.id, quantity: u.quantity, properties: u.properties }] }).then(refresh);
      return;
    }
    if (a === 'sheet-close') { closeSheet(); return; }
    if (a === 'edit-pick' && editCtx) {
      editCtx.sel[Number(act.dataset.i)] = act.dataset.v;
      var keep = q('[data-wv11-sheet-custom-input]', d); if (keep) sheetCtx.custom = keep.value;
      var shE = q('[data-wv11-sheet]', d); shE.innerHTML = editHtml();
      if (isCustom(act.dataset.v)) { var ci2 = q('[data-wv11-sheet-custom-input]', shE); if (ci2) ci2.focus({ preventScroll: true }); }
      return;
    }
    if (a === 'edit-save' && editCtx) {
      var ve = editVariant(editCtx.sel);
      if (!ve) return;
      var cIn = q('[data-wv11-sheet-custom-input]', d), cVal = cIn && !q('[data-wv11-sheet-custom]', d).hidden ? cIn.value.trim() : '';
      if (cIn && !q('[data-wv11-sheet-custom]', d).hidden && !cVal) { cIn.focus(); return; }
      if (ve.id === editCtx.cur.id && cVal === (sheetCtx.custom || '') ) { closeSheet(); return; }
      swapVariant(ve.id, cVal);
      return;
    }
    if (a === 'variant-pick') { if (act.dataset.variant) swapVariant(act.dataset.variant, ''); return; }
    if (a === 'sheet-custom') { var box = q('[data-wv11-sheet-custom]', d); if (box) { box.hidden = false; if (box.closest('[data-wv11-optdd]')) box.scrollIntoView({ block: 'nearest' }); var ip = q('input', box); if (ip) ip.focus({ preventScroll: true }); } return; }
    if (a === 'sheet-custom-save') { var inp = q('[data-wv11-sheet-custom-input]', d); var val = inp && inp.value.trim(); if (!val) { if (inp) inp.focus(); return; } swapVariant(act.dataset.variant, val); return; }
  });

  function alertInline(btn, err) {
    var p = document.createElement('p'); p.className = 'wv11-giftbar__note'; p.setAttribute('role', 'alert');
    p.textContent = (err && err.message) || 'Something went wrong. Please try again.';
    btn.insertAdjacentElement('afterend', p);
  }

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-wv11-custom]') && ui.panel) {
      ui.panel.custom = t.value;
      var foot = q('.wv11-panel__foot', drawer()); var s = readState();
      if (foot && s) { var tmp = document.createElement('div'); tmp.innerHTML = detailHtml(s); var nf = tmp.querySelector('.wv11-panel__foot'); if (nf) foot.innerHTML = nf.innerHTML; }
      return;
    }
    if (t.matches('[data-wv11-code-input]') && !t.value.trim()) { clearCodeNote(); return; }
    var input = t.closest('[data-wv11-search]');
    if (!input || !ui.panel) return;
    ui.panel.q = input.value;
    if (!refreshList()) {
      var pos = input.selectionStart;
      ui.panel.keepTop = true;
      renderPanel();
      var again = q('[data-wv11-search]', drawer()); if (again) { again.focus(); try { again.setSelectionRange(pos, pos); } catch (err) {} }
    }
  });

  // Moving the mouse back to the top of Browse brings the filter row back
  document.addEventListener('mouseover', function (e) {
    var pin = e.target.closest && e.target.closest('.wv11-pin.is-tucked');
    if (pin) pinStage(pin, 0);
  });

  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-wv11-scroll]') && ui.panel && ui.panel.view === 'list') onPanelScroll(t);
    if (t && t.matches && t.matches('[data-wv11-gallery]')) galleryBar(t);
  }, true);

  document.addEventListener('keydown', function (e) {
    var d = drawer(); if (!d) return;
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-wv11-code-input]')) { e.preventDefault(); var b = q('[data-wv11-code-apply]', d); if (b) b.click(); return; }
    if (e.key !== 'Escape') return;
    if (qa('.wv11-dd__list:not([hidden])', d).length) { closeLists(); e.stopPropagation(); return; }
    var sh = q('[data-wv11-sheet]', d);
    if (sh && !sh.hidden) { closeSheet(); e.stopPropagation(); return; }
    if (ui.panel && (ui.panel.open || ui.panel.sheet)) { ui.panel.open = null; ui.panel.sheet = false; ui.panel.keepTop = true; renderPanel(); e.stopPropagation(); return; }
    if (ui.panel) { closePanel(); e.stopPropagation(); }
  }, true);

  // Phones: swipe a piece left to show Delete; swipe the bag right to close it
  var touch = null;
  document.addEventListener('touchstart', function (e) {
    var d = drawer(); if (!d || !d.contains(e.target) || e.touches.length !== 1) return;
    if (ui.panel || lb || e.target.closest('[data-wv11-sheet], [data-wv11-lightbox]') || e.target.closest('input, select, .wv11-strip, .wv11-chips-row')) { touch = null; return; }
    var t = e.touches[0];
    touch = { x: t.clientX, y: t.clientY, row: e.target.closest('[data-wv11-swipe]'), dx: 0, locked: null };
  }, { passive: true });
  document.addEventListener('touchmove', function (e) {
    if (!touch) return;
    var t = e.touches[0]; var dx = t.clientX - touch.x, dy = t.clientY - touch.y;
    if (touch.locked == null && (Math.abs(dx) > 10 || Math.abs(dy) > 10)) touch.locked = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
    touch.dx = dx;
    if (touch.locked === 'x' && touch.row && dx < 0) {
      touch.row.classList.add('is-dragging');
      var lineEl = q('.wv11-line', touch.row); if (lineEl) lineEl.style.transform = 'translateX(' + Math.max(-touch.row.offsetWidth, dx) + 'px)';
    }
  }, { passive: true });
  document.addEventListener('touchend', function () {
    if (!touch) return;
    var t = touch; touch = null;
    if (t.row) { t.row.classList.remove('is-dragging'); var lineEl = q('.wv11-line', t.row); if (lineEl) lineEl.style.transform = ''; }
    if (t.locked !== 'x') return;
    // A long swipe (more than half the card) deletes straight away; Undo stays
    if (t.row && t.dx < -t.row.offsetWidth * 0.55) {
      var del = q('[data-wv11-swipe-delete]', t.row);
      var ln2 = q('.wv11-line', t.row); if (ln2) { ln2.style.transition = 'transform 0.2s ease'; ln2.style.transform = 'translateX(-100%)'; }
      if (del) setTimeout(function () { del.click(); }, 180);
      return;
    }
    if (t.row && t.dx < -50) {
      qa('.wv11-swipe.is-open').forEach(function (r) { if (r !== t.row) r.classList.remove('is-open'); });
      t.row.classList.add('is-open');
    } else if (t.row && t.dx > 30 && t.row.classList.contains('is-open')) {
      t.row.classList.remove('is-open');
    } else if (t.dx > 90 && !qa('.wv11-swipe.is-open').length) {
      closeDrawer();
    }
  }, { passive: true });

  /* ---------------- 5.9 second piece on product + collection pages ---------------- */

  // Product forms outside the bag (product page, quick add) carry the
  // second-piece mark while the offer is live and she already has a piece.
  function markForms(g) {
    var want = g && g.live && !g.hasSelection && g.paidUnits >= 1;
    qa('form[action*="/cart/add"]').forEach(function (form) {
      if (form.closest('.quick-cart')) return;
      var input = form.querySelector('input[name="properties[_womuse_selection]"]');
      if (want && !input) {
        input = document.createElement('input');
        input.type = 'hidden'; input.name = 'properties[_womuse_selection]'; input.value = '1';
        input.setAttribute('data-wv11-mark', '');
        form.appendChild(input);
      } else if (!want && input && input.hasAttribute('data-wv11-mark')) {
        input.remove();
      }
    });
  }

  var promptBusy = false;
  // Product page: "As your second piece: £70.40 (20% off)" just above the add
  // to bag button, and the same price in the sticky bar in place of the metal.
  // Collection pages: the line at the top (phones) and a promotion card in the
  // first row (desktop).
  function promptText(g, cents) {
    var t = String(g.promptProduct || '');
    if (t.indexOf('[price]') < 0) t = 'As your second piece: [price] ([percent]% off)';
    return t.replace(/\[percent\]/g, g.percent).replace(/\[price\]/g, money(cents, g.moneyFormat));
  }
  function selectedPrice(form, p) {
    var idEl = form && form.querySelector('[name="id"]');
    var v = idEl && p.variants.filter(function (x) { return String(x.id) === String(idEl.value); })[0];
    return v ? v.price : p.price;
  }
  function paintProductPrompt(g, p, form) {
    var cents = Math.round(selectedPrice(form, p) * (100 - g.percent) / 100);
    var txt = promptText(g, cents);
    var el = q('[data-wv11-prompt]');
    if (el) {
      var parts = txt.split(money(cents, g.moneyFormat));
      el.innerHTML = esc(parts[0]) + '<span class="wv11-prompt__price">' + esc(money(cents, g.moneyFormat)) + '</span>' + esc(parts.slice(1).join(money(cents, g.moneyFormat)));
    }
    var full = selectedPrice(form, p);
    qa('.sticky-atc-bar__price').forEach(function (bar) {
      var mine = q('[data-wv11-sticky-second]', bar);
      if (!mine) { mine = document.createElement('span'); mine.className = 'wv11-sticky-second'; mine.setAttribute('data-wv11-sticky-second', ''); bar.insertBefore(mine, bar.firstChild); }
      var html = 'Add a 2nd piece for <span class="wv11-sticky-second__now">' + esc(money(cents, g.moneyFormat)) + '</span> <s>' + esc(money(full, g.moneyFormat)) + '</s>';
      if (mine.innerHTML !== html) mine.innerHTML = html;
      bar.classList.add('wv11-has-second');
    });
    if (el) stickyLine(el.innerHTML);
  }
  // Phones, sticky Add to Bag at the bottom of the screen: the same line as above
  // the main button, word for word
  function stickyLine(html) {
    qa('[data-womuse-sticky-atc]').forEach(function (sb) {
      var ln = q('[data-wv11-sticky-line]', sb);
      if (!ln) { ln = document.createElement('div'); ln.className = 'wv11-sticky-line'; ln.setAttribute('data-wv11-sticky-line', ''); sb.insertBefore(ln, sb.firstChild); }
      if (ln.innerHTML !== html) ln.innerHTML = html;
    });
  }
  // Which offer the pages show: the second piece (she has one piece), then the
  // gift (the second piece is in, the gift amount not reached), then a note
  // that the gift is waiting in her bag. Nothing once she has chosen her gift.
  function offerMode(g) {
    if (!g) return '';
    if (g.live && !g.hasSelection && g.paidUnits >= 1) return 'second';
    if (g.hasSelection && g.giftThreshold > 0 && !g.giftKey) return g.giftReady ? 'ready' : 'gift';
    return '';
  }
  function giftAway(g) { return Math.max(0, (g.giftThreshold || 0) - (g.paidTotal || 0)); }
  function giftLine(g, mode, word) {
    if (mode === 'ready') return 'Your complimentary gift is waiting in your bag.';
    return 'Only ' + money(giftAway(g), g.moneyFormat) + ' away from a complimentary ' + word + '.';
  }
  function paintGiftPrompt(g, mode, p, form) {
    var txt = giftLine(g, mode, 'gift');
    if (mode === 'gift' && p && selectedPrice(form, p) >= giftAway(g)) txt = 'Add this piece and receive a complimentary gift.';
    var el = q('[data-wv11-prompt]');
    if (el && el.textContent !== txt) el.textContent = txt;
    stickyLine(esc(txt));
    // The bar at the top has little room: only the short line when this piece
    // reaches the gift; otherwise its usual price
    var short = mode === 'gift' && p && selectedPrice(form, p) >= giftAway(g) ? 'Unlocks a complimentary gift' : '';
    qa('.sticky-atc-bar__price').forEach(function (bar) {
      var mine = q('[data-wv11-sticky-second]', bar);
      if (!short) { if (mine) mine.remove(); bar.classList.remove('wv11-has-second'); return; }
      if (!mine) { mine = document.createElement('span'); mine.className = 'wv11-sticky-second'; mine.setAttribute('data-wv11-sticky-second', ''); bar.insertBefore(mine, bar.firstChild); }
      if (mine.textContent !== short) mine.textContent = short;
      bar.classList.add('wv11-has-second');
    });
  }
  function paintOffer(g, p, form) {
    var mode = offerMode(g);
    if (mode === 'second') paintProductPrompt(g, p, form);
    else if (mode) paintGiftPrompt(g, mode, p, form);
  }
  function clearProductPrompt() {
    qa('[data-wv11-sticky-second], [data-wv11-sticky-line]').forEach(function (x) { x.remove(); });
    qa('.wv11-has-second').forEach(function (x) { x.classList.remove('wv11-has-second'); });
  }
  function prompts(g) {
    var mode = offerMode(g);
    var sig = mode + '|' + (mode === 'gift' ? giftAway(g) : '');
    var pm = location.pathname.match(/\/products\/([^/?#]+)/);
    var existing = q('[data-wv11-prompt]');
    // The offer changed (another piece added, the gift amount moved): redraw
    if (existing && existing.getAttribute('data-wv11-sig') !== sig) { existing.remove(); existing = null; clearProductPrompt(); }
    qa('[data-wv11-promo]').forEach(function (c) { if (c.getAttribute('data-wv11-sig') !== sig) c.remove(); });
    if (!mode) { if (existing) existing.remove(); clearProductPrompt(); removePromoCard(); return; }
    if (!pm) promoCard(g, mode, sig);
    if (existing || promptBusy) return;

    if (pm && g.showPromptProduct) {
      var form = qa('form[action*="/cart/add"]').filter(function (f) { return !f.closest('.quick-cart') && !f.closest('[class*="quick-view"]') && !f.closest('[class*="sticky-atc"]'); })[0];
      var submit = form && form.querySelector('[type="submit"], [name="add"]');
      if (!submit) return;
      promptBusy = true;
      Promise.all([loadCatalog(null), loadProduct(pm[1])]).then(function () {
        promptBusy = false;
        if (q('[data-wv11-prompt]') || (mode === 'second' && !catalog.byHandle[pm[1]])) return;
        var p = products[pm[1]];
        if (!p) return;
        var el = document.createElement('p');
        el.className = 'wv11-prompt wv11-prompt--product'; el.setAttribute('data-wv11-prompt', ''); el.setAttribute('data-wv11-sig', sig);
        var anchor = submit.closest('.product-form__item, .product__buy-buttons, .product-form__buttons') || submit;
        anchor.insertAdjacentElement('beforebegin', el);
        paintOffer(g, p, form);
        if (!form.dataset.wv11PromptWatch) {
          form.dataset.wv11PromptWatch = '1';
          form.addEventListener('change', function () { setTimeout(function () { var gg = readGlobal(); if (gg && q('[data-wv11-prompt]')) paintOffer(gg, p, form); }, 60); });
        }
      }).catch(function () { promptBusy = false; });
      return;
    }

    if (/\/collections\//.test(location.pathname) && !pm && g.showPromptCollection) {
      var grid = q('main [data-section-type="collection"] .collection__products, main .collection__products, main [data-product-grid], main .product-grid');
      if (!grid) return;
      var line = document.createElement('p');
      line.className = 'wv11-prompt wv11-prompt--collection'; line.setAttribute('data-wv11-prompt', ''); line.setAttribute('data-wv11-sig', sig);
      line.textContent = mode === 'second' ? fill(g.promptCollection, g) : giftLine(g, mode, 'piece');
      grid.parentNode.insertBefore(line, grid);
    }
  }

  // Desktop collection pages: one card in the first row, showing the piece the
  // bag is suggesting to go with hers. Tapping it opens the bag on her private
  // selection. Words and the on/off switch come from the theme editor.
  var promoBusy = false;
  function removePromoCard() { qa('[data-wv11-promo]').forEach(function (x) { x.remove(); }); }
  function giftCard(g, mode, sig, grid) {
    var items = qa(':scope > .product-item, :scope > *', grid).filter(function (x) { return x.matches('.product-item') || x.querySelector('.product-item'); });
    var at = items[2] || null;
    var card = document.createElement('div');
    card.className = 'wv11-promo wv11-promo--gift'; card.setAttribute('data-wv11-promo', ''); card.setAttribute('data-wv11-sig', sig);
    // Still an amount to spend: she keeps browsing, the card opens nothing.
    // Gift waiting: the card and its button open the bag at the gift.
    var ready = mode === 'ready';
    card.innerHTML = (ready ? '<button type="button" class="wv11-promo__open" data-wv11-gift-open>' : '<div class="wv11-promo__open wv11-promo__open--static">') +
      (g.giftCardImage ? '<span class="wv11-promo__media"><img src="' + esc(g.giftCardImage) + '" alt="" loading="lazy"></span>' : '') +
      '<span class="wv11-promo__text"><span class="wv11-promo__eb">' + esc(g.giftEyebrow || 'A gift from WOMUSE') + '</span>' +
      '<span class="wv11-promo__title">' + esc(giftLine(g, mode, 'piece')) + '</span></span>' + (ready ? '</button>' : '</div>') +
      (ready ? '<button type="button" class="wv11-promo__gift-btn" data-wv11-gift-open>Choose your gift</button>' :
      '<button type="button" class="wv11-promo__how" data-wv11-promo-how aria-expanded="false">' + esc(g.promoLink) + '</button>') +
      '<div class="wv11-promo__steps" data-wv11-promo-steps hidden><button type="button" class="wv11-promo__x" data-wv11-promo-how aria-label="Close">' + ICON.close + '</button>' +
      '<ol><li>Your bag reaches ' + esc(money(g.giftThreshold, g.moneyFormat)) + '.</li><li>Choose your gift in the bag.</li><li>It is added at no cost.</li></ol></div>';
    if (at) grid.insertBefore(card, at); else grid.appendChild(card);
  }
  function promoCard(g, mode, sig) {
    if (!g.promoCard || !/\/collections\//.test(location.pathname)) { removePromoCard(); return; }
    var grid = q('main .collection__products');
    if (!grid || q('[data-wv11-promo]', grid) || promoBusy) return;
    if (mode !== 'second') { giftCard(g, mode, sig, grid); return; }
    var s = readState(); if (!s) return;
    promoBusy = true;
    loadCatalog(s).then(function () {
      promoBusy = false;
      if (q('[data-wv11-promo]', grid)) return;
      var A = suggestion(s); if (!A) return;
      var items = qa(':scope > .product-item, :scope > *', grid).filter(function (x) { return x.matches('.product-item') || x.querySelector('.product-item'); });
      var at = items[2] || null;
      var card = document.createElement('div');
      card.className = 'wv11-promo'; card.setAttribute('data-wv11-promo', ''); card.setAttribute('data-wv11-sig', sig);
      card.innerHTML = '<button type="button" class="wv11-promo__open" data-wv11-promo-open aria-label="' + esc(fill(g.promoTitle, g)) + '">' +
        '<span class="wv11-promo__media"><img src="' + esc(A.i) + '" alt="" loading="lazy"><span class="wv11-lock">' + ICON.lock + '</span></span>' +
        '<span class="wv11-promo__text"><span class="wv11-promo__eb">' + esc(g.promoEyebrow) + '</span>' +
        '<span class="wv11-promo__title">' + esc(fill(g.promoTitle, g)) + '</span>' +
        '<span class="wv11-promo__piece">Chosen to go with yours. Unlock to see it.</span></span></button>' +
        '<button type="button" class="wv11-promo__how" data-wv11-promo-how aria-expanded="false">' + esc(g.promoLink) + '</button>' +
        '<div class="wv11-promo__steps" data-wv11-promo-steps hidden><button type="button" class="wv11-promo__x" data-wv11-promo-how aria-label="Close">' + ICON.close + '</button>' +
        '<ol><li>Choose any piece.</li><li>Add a second piece.</li><li>The second is ' + esc(String(g.percent)) + '% off, applied in your bag.</li></ol></div>';
      if (at) grid.insertBefore(card, at); else grid.appendChild(card);
    }).catch(function () { promoBusy = false; });
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-wv11-promo-steps]') && !e.target.closest('[data-wv11-promo-how]')) {
      qa('[data-wv11-promo-steps]:not([hidden])').forEach(function (st0) {
        st0.hidden = true;
        var c0 = st0.closest('[data-wv11-promo]'); var h0 = c0 && q('.wv11-promo__how', c0); if (h0) h0.setAttribute('aria-expanded', 'false');
      });
    }
    var how = e.target.closest('[data-wv11-promo-how]');
    if (how) {
      e.preventDefault();
      var card = how.closest('[data-wv11-promo]'); var st = q('[data-wv11-promo-steps]', card);
      st.hidden = !st.hidden;
      q('.wv11-promo__how', card).setAttribute('aria-expanded', String(!st.hidden));
      return;
    }
    if (e.target.closest('[data-wv11-gift-open]')) {
      e.preventDefault();
      var dg = drawer();
      var gicon = q('[data-js-cart-icon]');
      if (gicon && !(dg && dg.classList.contains('active'))) gicon.click();
      setTimeout(function () {
        var gc = q('.wv11-giftcard', drawer()); if (gc && gc.scrollIntoView) gc.scrollIntoView({ block: 'center', behavior: REDUCED ? 'auto' : 'smooth' });
      }, 450);
      return;
    }
    if (e.target.closest('[data-wv11-promo-open]')) {
      e.preventDefault();
      var d = drawer();
      var icon = q('[data-js-cart-icon]');
      if (icon && !(d && d.classList.contains('active'))) icon.click();
      setTimeout(function () {
        ui.sel = 'open'; renderRewards();
        var sel = q('.wv11-selector', drawer()); if (sel && sel.scrollIntoView) sel.scrollIntoView({ block: 'start', behavior: REDUCED ? 'auto' : 'smooth' });
      }, 450);
    }
  });

  /* ---------------- 5.9b favourites across the site ---------------- */

  // Header heart (between Contact us and the account icon), a heart next to
  // the product title, and a heart on every collection card. All share the
  // same favourites list as the bag.
  function handleFromUrl(href) { var m = String(href || '').match(/\/products\/([^/?#]+)/); return m ? m[1] : ''; }

  function siteHearts() {
    // Header
    qa('.womuse-header__right, .header__row-segment.right').forEach(function (seg) {
      if (q('[data-wv11-header-fav]', seg)) return;
      var cart = q('[data-js-cart-icon]', seg); if (!cart) return;
      var anchor = q('.header__icon-touch--account', seg) || cart;
      var b = document.createElement('a');
      b.href = FAV_URL; b.className = 'header__icon-touch wv11-header-fav'; b.setAttribute('data-wv11-header-fav', '');
      b.setAttribute('aria-label', 'Your favourites');
      b.innerHTML = ICON.heart + '<span class="wv11-header-fav__count" data-wv11-fav-count hidden></span>';
      anchor.parentNode.insertBefore(b, anchor);
    });
    // Product page title
    var pm = location.pathname.match(/\/products\/([^/?#]+)/);
    if (pm) {
      var title = q('main .product__title, main h1');
      if (title && !q('[data-wv11-fav]', title)) {
        var wrap = document.createElement('span'); wrap.className = 'wv11-pdp-fav';
        wrap.innerHTML = heartBtn(decodeURIComponent(pm[1]), title.textContent.trim());
        title.appendChild(wrap);
      }
    }
    // Collection and product grid cards
    qa('.product-item').forEach(function (card) {
      if (card.closest('.quick-cart') || q('[data-wv11-fav]', card)) return;
      var media = q('.product-item__media', card), link = q('a[href*="/products/"]', card);
      if (!media || !link) return;
      var h = handleFromUrl(link.getAttribute('href')); if (!h) return;
      media.insertAdjacentHTML('beforeend', heartBtn(h, link.getAttribute('aria-label') || '').replace('class="wv11-heart"', 'class="wv11-heart wv11-heart--card"'));
    });
    paintHearts();
  }

  function paintFavCount() {
    var n = favs().length;
    qa('[data-wv11-fav-count]').forEach(function (c) {
      // Write only when the number changes, so the page watcher is not woken again
      if (c.textContent !== String(n)) c.textContent = n;
      if (c.hidden !== !n) c.hidden = !n;
    });
  }

  /* ---------------- 5.9c favourites notice + favourites page ---------------- */

  // Name and photo for the notice and the favourites page
  function pieceInfo(h) {
    var c = catalog && catalog.byHandle[h];
    if (c) return Promise.resolve({ title: c.t, image: c.i });
    return loadProduct(h).then(function (p) {
      return p && p.title ? { title: p.title, image: p.featured_image ? img600(p.featured_image) + (String(p.featured_image).indexOf('?') >= 0 ? '&' : '?') + 'width=300' : '' } : null;
    }).catch(function () { return null; });
  }

  // "… has been added to your favourites" with the photo and a link;
  // "… has been removed from your favourites" without either
  var toastTimer = 0;
  function hideToast() {
    var el = q('[data-wv11-toast]'); if (!el) return;
    el.classList.remove('is-in');
    setTimeout(function () { if (!el.classList.contains('is-in')) el.hidden = true; }, 250);
  }
  // The photo already showing on the page for this piece (card or product page),
  // so the notice never downloads a fresh copy
  function shownPhoto(btn) {
    var box = btn && (btn.closest('.product-item, .wv11-fpcard') || (btn.closest('main') && /\/products\//.test(location.pathname) ? q('main') : null));
    var im = box && qa('img', box).filter(function (i) { return i.complete && i.naturalWidth > 0 && i.getBoundingClientRect().width > 40; })[0];
    return im ? (im.currentSrc || im.src) : '';
  }
  function favToast(h, added, shown) {
    pieceInfo(h).then(function (p) {
      if (p && shown) p.image = shown;
      var el = q('[data-wv11-toast]');
      if (!el) {
        el = document.createElement('div');
        el.className = 'wv11-toast'; el.setAttribute('data-wv11-toast', ''); el.setAttribute('role', 'status'); el.setAttribute('aria-live', 'polite');
        el.hidden = true;
        document.body.appendChild(el);
      }
      var name = p ? p.title : 'This piece';
      var img = added && p && p.image;
      el.classList.toggle('wv11-toast--img', !!img);
      el.innerHTML = (img ? '<img class="wv11-toast__img" src="' + esc(p.image) + '" alt="">' : '') +
        '<div class="wv11-toast__text"><p>' + esc(name) + (added ? ' has been added to your favourites.' : ' has been removed from your favourites.') + '</p>' +
        (added && !q('[data-wv11-favpage]') ? '<a class="wv11-toast__link" href="' + FAV_URL + '">View your favourites</a>' : '') + '</div>' +
        '<button type="button" class="wv11-toast__x" data-wv11-toast-close aria-label="Close">' + ICON.close + '</button>';
      el.hidden = false;
      requestAnimationFrame(function () { el.classList.add('is-in'); });
      clearTimeout(toastTimer);
      toastTimer = setTimeout(hideToast, 5000);
    });
  }

  // The theme's own bag icon (the one in the header)
  var BAG_ICON = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M16.148 11.479c-.101-1.428-.125-2.985-.296-4.57C15.577 4.37 14.372 2.64 12 2.64S8.423 4.37 8.148 6.908c-.171 1.586-.195 3.142-.296 4.57" stroke="currentColor" stroke-width="1.2" stroke-miterlimit="10" stroke-linejoin="bevel"/><path d="M20.701 20.438V8.816H3.3v11.622H20.7z" stroke="currentColor" stroke-width="1.2" stroke-miterlimit="10"/></svg>';

  function fpCard(p, mf, removable) {
    var href = ROOT + 'products/' + p.handle;
    var img = p.featured_image ? img600(p.featured_image) + (String(p.featured_image).indexOf('?') >= 0 ? '&' : '?') + 'width=700' : '';
    var price = (p.price_varies ? 'From ' : '') + money(p.price, mf);
    return '<div class="wv11-fpcard">' +
      '<a class="wv11-fpcard__media" href="' + esc(href) + '" tabindex="-1" aria-hidden="true">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</a>' +
      (removable ? '<button type="button" class="wv11-fpcard__x" data-wv11-fp="remove" data-handle="' + esc(p.handle) + '" aria-label="Remove ' + esc(p.title) + ' from your favourites" data-hint="Remove from favourites">' + ICON.heartFull + '</button>' :
        heartBtn(p.handle, p.title).replace('class="wv11-heart"', 'class="wv11-heart wv11-heart--card"')) +
      '<div class="wv11-fpcard__row"><a class="wv11-fpcard__info" href="' + esc(href) + '"><span class="wv11-fpcard__name">' + esc(shortTitle(p.title)) + (shortTitle(p.title) !== p.title ? '<span class="wv23-hide">' + esc(p.title.slice(shortTitle(p.title).length)) + '</span>' : '') + '</span><span class="wv11-fpcard__price">' + price + '</span></a>' +
      (p.available ? '<button type="button" class="wv11-fpcard__bag" data-wv11-fp="bag" data-handle="' + esc(p.handle) + '" aria-label="Add ' + esc(p.title) + ' to your bag">' + BAG_ICON + '</button>' : '<span class="wv11-fpcard__sold">Sold out</span>') +
      '</div></div>';
  }

  function sharedList() {
    var m = location.search.match(/[?&]f=([^&]+)/);
    return m ? decodeURIComponent(m[1]).split(',').filter(Boolean).slice(0, 60) : null;
  }

  function favPage(force) {
    var root = q('[data-wv11-favpage]'); if (!root) return;
    var shared = sharedList();
    var handles = shared || favs();
    var sig = (shared ? 's:' : '') + handles.join(',');
    if (!force && root.dataset.sig === sig) return;
    root.dataset.sig = sig;
    Promise.all(handles.map(function (h) { return loadProduct(h).catch(function () { return null; }); })).then(function () {
      if (root.dataset.sig !== sig) return;
      var g = readGlobal() || {}, mf = g.moneyFormat;
      var ok = function (h) { return products[h] && products[h].handle; };
      var mine = handles.filter(ok);
      var t = root.dataset;
      var h = '<div class="wv11-fp__head"><h1 class="wv11-fp__title">' + esc(shared ? t.sharedTitle : t.title) + '</h1>';
      if (mine.length) {
        h += '<p class="wv11-fp__sub">' + esc(shared ? t.sharedText : t.text) + '</p><div class="wv11-fp__actions">';
        h += shared ? '<button type="button" class="wv11-fp__btn wv11-fp__btn--dark" data-wv11-fp="save-all">Save to my favourites</button>' :
          '<button type="button" class="wv11-fp__btn" data-wv11-fp="share"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M12 15V3M7 8l5-5 5 5M5 13v7h14v-7"/></svg><span>Share</span></button>';
        h += '</div>';
      } else {
        h += '<p class="wv11-fp__sub">' + esc(t.empty) + '</p><div class="wv11-fp__actions"><a class="wv11-fp__btn wv11-fp__btn--dark" href="' + ROOT + 'collections/all">Explore the collection</a></div>';
      }
      h += '</div>';
      if (mine.length) h += '<div class="wv11-fp__grid">' + mine.map(function (x) { return fpCard(products[x], mf, !shared); }).join('') + '</div>';
      root.innerHTML = h;
      root.classList.add('is-ready');
      paintHearts();
    });
  }

  function openBagPiece(handle) {
    var d = drawer();
    var cartIcon = q('[data-js-cart-icon]');
    if (cartIcon && !(d && d.classList.contains('active'))) cartIcon.click();
    setTimeout(function () { openPanel('detail', handle); }, 350);
  }

  // Hearts and favourites page buttons outside the bag
  document.addEventListener('click', function (e) {
    var d = drawer();
    if (d && d.contains(e.target)) return;
    if (e.target.closest('[data-wv11-toast-close]')) { e.preventDefault(); clearTimeout(toastTimer); hideToast(); return; }
    var fav = e.target.closest('[data-wv11-fav]');
    if (fav) {
      e.preventDefault(); e.stopPropagation();
      var h = fav.dataset.wv11Fav, adding = !isFav(h);
      toggleFav(h); paintFavCount(); favToast(h, adding, adding ? shownPhoto(fav) : ''); favPage();
      // A tiny pop when she saves
      if (adding) { fav.classList.remove('is-pop'); void fav.offsetWidth; fav.classList.add('is-pop'); }
      return;
    }
    var fp = e.target.closest('[data-wv11-fp]');
    if (!fp) return;
    e.preventDefault();
    var what = fp.dataset.wv11Fp;
    if (what === 'remove') { toggleFav(fp.dataset.handle); paintFavCount(); favToast(fp.dataset.handle, false); favPage(); return; }
    if (what === 'bag') { openBagPiece(fp.dataset.handle); return; }
    if (what === 'save-all') {
      var list = favs(); (sharedList() || []).forEach(function (x) { if (list.indexOf(x) < 0) list.push(x); });
      keep(FAV_KEY, list.slice(0, 60)); paintFavCount();
      location.href = FAV_URL; return;
    }
    if (what === 'share') {
      var url = location.origin + FAV_URL + '&f=' + encodeURIComponent(favs().join(','));
      var done = function () { var sp = q('span', fp); if (sp) { sp.textContent = 'Link copied'; setTimeout(function () { sp.textContent = 'Share'; }, 2500); } };
      if (navigator.share && /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)) { navigator.share({ title: 'My WOMUSE favourites', url: url }).catch(function () {}); return; }
      if (navigator.clipboard) navigator.clipboard.writeText(url).then(done).catch(function () { window.prompt('Copy this link', url); });
      else window.prompt('Copy this link', url);
    }
  }, true);

  window.addEventListener('resize', function () { qa('[data-wv11-gallery]').forEach(galleryBar); });

  // Sheets rising from the bottom (bag sheets and the product page size
  // sheet): drag the handle or the title row down to close
  var sheetDrag = null;
  document.addEventListener('touchstart', function (e) {
    if (!e.target.closest || e.target.closest('button')) return;
    var grab = e.target.closest('.wv11-sheet__grab, .wv11-sheet__head, .womuse-size-selector__mobile-header, .womuse-mto-disclosure__mobile-handle, .womuse-mto-disclosure__mobile-header');
    var card = grab && grab.closest('.wv11-sheet__card, .womuse-size-selector__panel, .womuse-mto-disclosure__panel');
    if (!card) return;
    var xSel = card.classList.contains('womuse-size-selector__panel') ? '[data-womuse-size-close]' : card.classList.contains('womuse-mto-disclosure__panel') ? '.womuse-mto-disclosure__close' : '';
    var shut = xSel ? function () { var x = q(xSel, card) || q(xSel); if (x) x.click(); setTimeout(function () { card.style.transform = ''; card.style.transition = ''; }, 400); } : closeSheet;
    sheetDrag = { card: card, y0: e.touches[0].clientY, dy: 0, shut: shut };
    card.style.transition = 'none';
  }, { passive: true });
  document.addEventListener('touchmove', function (e) {
    if (!sheetDrag) return;
    sheetDrag.dy = Math.max(0, e.touches[0].clientY - sheetDrag.y0);
    sheetDrag.card.style.transform = 'translateY(' + sheetDrag.dy + 'px)';
  }, { passive: true });
  document.addEventListener('touchend', function () {
    if (!sheetDrag) return;
    var g = sheetDrag; sheetDrag = null;
    g.card.style.transition = 'transform 0.25s ease';
    if (g.dy > 90) { g.card.style.transform = 'translateY(100%)'; setTimeout(g.shut, 220); }
    else g.card.style.transform = '';
  });

  // Phones, while she scrolls the bag:
  // the header slides away when her finger moves the list up and returns when it
  // moves it down, or after 5 seconds still; the footer becomes one slim line
  // (total and checkout) while she moves and opens again after 2 seconds still,
  // or near the top.
  // The footer (handle or anywhere on it): drag down for the slim line, drag up
  // to open it, or tap the handle. Made slim by hand, it stays slim until she
  // scrolls the cards again.
  // Steady hands: the header needs a clear change of direction (24px), waits
  // until its last slide has finished, and stays put at the very end of the bag,
  // so a held finger or the end bounce never makes the cards jump.
  // Only her finger starts the motion: the bag changing size afterwards (which
  // the browser also reports as scrolling) never triggers it again.
  var headT = 0, footT = 0, bagTouch = null, footHand = false, grab = null, headAt = 0;
  function bagForm(t) { var f = t && t.closest && t.closest('.quick-cart__form'); var d = drawer(); return f && d && d.contains(f) && window.innerWidth <= 959 ? f : null; }
  function bagHead(d, away) {
    if (away === d.classList.contains('wv11-head-away')) return;
    if (away) {
      var h = q('.quick-cart__header', d), w = q('.wv11-delivery-wrap', d);
      d.style.setProperty('--wv11-headh', ((h ? h.offsetHeight : 0) + (w ? w.offsetHeight : 0)) + 'px');
    }
    d.classList.toggle('wv11-head-away', away);
    headAt = Date.now();
  }
  function bagSlim(d, slim) { if (slim !== d.classList.contains('wv11-foot-slim')) d.classList.toggle('wv11-foot-slim', slim); }
  function bagIdle(d) {
    clearTimeout(headT); headT = setTimeout(function () { bagHead(d, false); }, 5000);
    clearTimeout(footT); if (!footHand) footT = setTimeout(function () { bagSlim(d, false); }, 2000);
  }
  document.addEventListener('touchstart', function (e) {
    var g = e.target.closest && (e.target.closest('[data-wv11-foot-grab]') ||
      (bagForm(e.target) && !e.target.closest('input, textarea, select') && e.target.closest('.quick-cart__footer')));
    grab = g && e.touches.length === 1 ? { y0: e.touches[0].clientY, dy: 0 } : null;
    var f = !g && bagForm(e.target); bagTouch = f && e.touches.length === 1 ? { f: f, y: e.touches[0].clientY, acc: 0 } : null;
  }, { passive: true });
  document.addEventListener('touchmove', function (e) {
    if (grab) { grab.dy = e.touches[0].clientY - grab.y0; return; }
    if (!bagTouch) return;
    var y = e.touches[0].clientY, dy = y - bagTouch.y; bagTouch.y = y;
    bagTouch.acc = (bagTouch.acc > 0) === (dy > 0) ? bagTouch.acc + dy : dy;
    if (Math.abs(bagTouch.acc) < 10) return;
    var d = drawer(), f = bagTouch.f;
    var nearTop = f.scrollTop < 30, atEnd = f.scrollTop + f.clientHeight >= f.scrollHeight - 2;
    footHand = false;
    if (nearTop) bagHead(d, false);
    else if (!atEnd && Math.abs(bagTouch.acc) >= 24 && Date.now() - headAt > 450) bagHead(d, bagTouch.acc < 0);
    bagSlim(d, !ui.codeOpen && !nearTop);
    bagIdle(d);
  }, { passive: true });
  document.addEventListener('touchend', function () {
    bagTouch = null;
    if (!grab) return;
    var d = drawer(), dy = grab.dy; grab = null;
    if (!d || Math.abs(dy) < 25) return;
    footT && clearTimeout(footT);
    footHand = dy > 0; bagSlim(d, footHand);
  });
  // A tap on the handle (and a mouse click) opens the slim footer again
  document.addEventListener('click', function (e) {
    var g = e.target.closest && e.target.closest('[data-wv11-foot-grab]'); if (!g) return;
    e.preventDefault();
    var d = drawer(); if (!d || !d.classList.contains('wv11-foot-slim')) return;
    clearTimeout(footT); footHand = false; bagSlim(d, false);
  });
  // Momentum after her finger lifts keeps the timers waiting; top and end restore
  document.addEventListener('scroll', function (e) {
    var f = bagForm(e.target); if (!f) return;
    var d = drawer();
    if (!d.classList.contains('wv11-head-away') && !d.classList.contains('wv11-foot-slim')) return;
    if (f.scrollTop < 30) { bagHead(d, false); if (!footHand) bagSlim(d, false); return; }
    if (bagTouch) return;
    bagIdle(d);
  }, true);

  /* ---------------- 5.10 keep everything in step ---------------- */

  var raf = 0, staleFor = '';
  function sync() {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(function () {
      var g = readGlobal();
      markForms(g);
      prompts(g);
      siteHearts(); paintFavCount(); favPage();
      // The theme's own buttons (Add to Shopping Bag, sticky bar): the W in place of its loading bar
      qa('.btn__loading-wrap:not([data-wv-load])').forEach(function (w) { w.setAttribute('data-wv-load', ''); w.insertAdjacentHTML('beforeend', loader()); });
      var d = drawer(); if (!d) return;
      if (!q('.quick-cart__wrapper.active', d)) { d.classList.remove('wv11-head-away', 'wv11-foot-slim'); footHand = false; }
      var ft = q('.quick-cart__footer', d);
      if (ft && !q('[data-wv11-foot-grab]', ft)) ft.insertAdjacentHTML('afterbegin', '<button type="button" class="wv11-foot-grab" data-wv11-foot-grab aria-label="Make the total smaller or larger"></button>');
      if (q('.quick-cart__empty-state', d) && !q('[data-wv11-undo]', d) && load(UNDO_KEY)) renderUndo();
      // iPhone: the theme only lets marked areas scroll while the bag is open
      qa('[data-wv11-panel]:not([data-scroll-lock-ignore]), [data-wv11-sheet]:not([data-scroll-lock-ignore])', d).forEach(function (x) { x.setAttribute('data-scroll-lock-ignore', ''); });
      var mount = q('[data-wv11-rewards]', d);
      if (mount && mount.dataset.wv11Done !== '1') {
        var s = readState();
        if (s && s.hasSelection) { ui.sel = 'closed'; ui.selMetal = null; }
        if (s && s.giftKey) ui.altOpen = false;
        renderRewards(); renderUndo(); restoreFooter(); renderChips(); keepOneMark(); keepGiftHonest(); paintHearts(); paintRingPills();
        // The theme redraws only the pieces after its own add to bag: bring the
        // title, delivery row and total up to date as well
        var stampEl = q('[data-wv11-stamp]', d);
        if (s && s.stamp && stampEl && stampEl.getAttribute('data-wv11-stamp') !== s.stamp && staleFor !== s.stamp) { staleFor = s.stamp; refresh(); }
      }
      var panel = q('[data-wv11-panel]', d);
      if (panel && ui.panel && panel.hidden) renderPanel();
    });
  }
  new MutationObserver(sync).observe(document.documentElement, { childList: true, subtree: true });

  function start() { recordRecent(); sync(); warmCatalog(); }
  // Product pages: fetch the bag's selection list quietly once the page has
  // finished, so the first add to bag never waits for it (kept 30 minutes)
  function warmCatalog() {
    if (!/\/products\//.test(location.pathname)) return;
    var go = function () { (window.requestIdleCallback || function (f) { setTimeout(f, 1500); })(function () { loadCatalog(null); }); };
    if (document.readyState === 'complete') go(); else window.addEventListener('load', go, { once: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();

/* ---------------------------------------------------------
V36 · An empty bag shows no count bubble on the bag icon.
The theme keeps "0" in the bubble; marked here, hidden in womuse-v11-bag.css.
--------------------------------------------------------- */
(function () {
  'use strict';
  function mark() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-js-cart-count]'), function (el) {
      var n = parseInt(el.textContent, 10);
      if (!n) el.setAttribute('data-wv-empty', ''); else el.removeAttribute('data-wv-empty');
    });
  }
  mark();
  var t = 0;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(mark, 30); })
    .observe(document.querySelector('header') || document.body, { childList: true, characterData: true, subtree: true });
  document.addEventListener('cart:updated', function () { setTimeout(mark, 60); });
})();
